/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/pull-element/demo/build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	module.exports = __webpack_require__(9);


/***/ },
/* 1 */
/***/ function(module, exports) {

	/*!
	 * react-lite.js v0.15.39
	 * (c) 2017 Jade Gu
	 * Released under the MIT License.
	 */
	'use strict';
	
	var HTML_KEY = 'dangerouslySetInnerHTML';
	var SVGNamespaceURI = 'http://www.w3.org/2000/svg';
	var COMPONENT_ID = 'liteid';
	var VELEMENT = 2;
	var VSTATELESS = 3;
	var VCOMPONENT = 4;
	var VCOMMENT = 5;
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * current stateful component's refs property
	 * will attach to every vnode created by calling component.render method
	 */
	var refs = null;
	
	function createVnode(vtype, type, props, key, ref) {
	    var vnode = {
	        vtype: vtype,
	        type: type,
	        props: props,
	        refs: refs,
	        key: key,
	        ref: ref
	    };
	    if (vtype === VSTATELESS || vtype === VCOMPONENT) {
	        vnode.uid = getUid();
	    }
	    return vnode;
	}
	
	function initVnode(vnode, parentContext, namespaceURI) {
	    var vtype = vnode.vtype;
	
	    var node = null;
	    if (!vtype) {
	        // init text
	        node = document.createTextNode(vnode);
	    } else if (vtype === VELEMENT) {
	        // init element
	        node = initVelem(vnode, parentContext, namespaceURI);
	    } else if (vtype === VCOMPONENT) {
	        // init stateful component
	        node = initVcomponent(vnode, parentContext, namespaceURI);
	    } else if (vtype === VSTATELESS) {
	        // init stateless component
	        node = initVstateless(vnode, parentContext, namespaceURI);
	    } else if (vtype === VCOMMENT) {
	        // init comment
	        node = document.createComment('react-text: ' + (vnode.uid || getUid()));
	    }
	    return node;
	}
	
	function updateVnode(vnode, newVnode, node, parentContext) {
	    var vtype = vnode.vtype;
	
	    if (vtype === VCOMPONENT) {
	        return updateVcomponent(vnode, newVnode, node, parentContext);
	    }
	
	    if (vtype === VSTATELESS) {
	        return updateVstateless(vnode, newVnode, node, parentContext);
	    }
	
	    // ignore VCOMMENT and other vtypes
	    if (vtype !== VELEMENT) {
	        return node;
	    }
	
	    var oldHtml = vnode.props[HTML_KEY] && vnode.props[HTML_KEY].__html;
	    if (oldHtml != null) {
	        updateVelem(vnode, newVnode, node, parentContext);
	        initVchildren(newVnode, node, parentContext);
	    } else {
	        updateVChildren(vnode, newVnode, node, parentContext);
	        updateVelem(vnode, newVnode, node, parentContext);
	    }
	    return node;
	}
	
	function updateVChildren(vnode, newVnode, node, parentContext) {
	    var patches = {
	        removes: [],
	        updates: [],
	        creates: []
	    };
	    diffVchildren(patches, vnode, newVnode, node, parentContext);
	    flatEach(patches.removes, applyDestroy);
	    flatEach(patches.updates, applyUpdate);
	    flatEach(patches.creates, applyCreate);
	}
	
	function applyUpdate(data) {
	    if (!data) {
	        return;
	    }
	    var vnode = data.vnode;
	    var newNode = data.node;
	
	    // update
	    if (!data.shouldIgnore) {
	        if (!vnode.vtype) {
	            newNode.replaceData(0, newNode.length, data.newVnode);
	        } else if (vnode.vtype === VELEMENT) {
	            updateVelem(vnode, data.newVnode, newNode, data.parentContext);
	        } else if (vnode.vtype === VSTATELESS) {
	            newNode = updateVstateless(vnode, data.newVnode, newNode, data.parentContext);
	        } else if (vnode.vtype === VCOMPONENT) {
	            newNode = updateVcomponent(vnode, data.newVnode, newNode, data.parentContext);
	        }
	    }
	
	    // re-order
	    var currentNode = newNode.parentNode.childNodes[data.index];
	    if (currentNode !== newNode) {
	        newNode.parentNode.insertBefore(newNode, currentNode);
	    }
	    return newNode;
	}
	
	function applyDestroy(data) {
	    destroyVnode(data.vnode, data.node);
	    data.node.parentNode.removeChild(data.node);
	}
	
	function applyCreate(data) {
	    var node = initVnode(data.vnode, data.parentContext, data.parentNode.namespaceURI);
	    data.parentNode.insertBefore(node, data.parentNode.childNodes[data.index]);
	}
	
	/**
	 * Only vnode which has props.children need to call destroy function
	 * to check whether subTree has component that need to call lify-cycle method and release cache.
	 */
	
	function destroyVnode(vnode, node) {
	    var vtype = vnode.vtype;
	
	    if (vtype === VELEMENT) {
	        // destroy element
	        destroyVelem(vnode, node);
	    } else if (vtype === VCOMPONENT) {
	        // destroy state component
	        destroyVcomponent(vnode, node);
	    } else if (vtype === VSTATELESS) {
	        // destroy stateless component
	        destroyVstateless(vnode, node);
	    }
	}
	
	function initVelem(velem, parentContext, namespaceURI) {
	    var type = velem.type;
	    var props = velem.props;
	
	    var node = null;
	
	    if (type === 'svg' || namespaceURI === SVGNamespaceURI) {
	        node = document.createElementNS(SVGNamespaceURI, type);
	        namespaceURI = SVGNamespaceURI;
	    } else {
	        node = document.createElement(type);
	    }
	
	    initVchildren(velem, node, parentContext);
	
	    var isCustomComponent = type.indexOf('-') >= 0 || props.is != null;
	    setProps(node, props, isCustomComponent);
	
	    if (velem.ref != null) {
	        addItem(pendingRefs, velem);
	        addItem(pendingRefs, node);
	    }
	
	    return node;
	}
	
	function initVchildren(velem, node, parentContext) {
	    var vchildren = node.vchildren = getFlattenChildren(velem);
	    var namespaceURI = node.namespaceURI;
	    for (var i = 0, len = vchildren.length; i < len; i++) {
	        node.appendChild(initVnode(vchildren[i], parentContext, namespaceURI));
	    }
	}
	
	function getFlattenChildren(vnode) {
	    var children = vnode.props.children;
	
	    var vchildren = [];
	    if (isArr(children)) {
	        flatEach(children, collectChild, vchildren);
	    } else {
	        collectChild(children, vchildren);
	    }
	    return vchildren;
	}
	
	function collectChild(child, children) {
	    if (child != null && typeof child !== 'boolean') {
	        if (!child.vtype) {
	            // convert immutablejs data
	            if (child.toJS) {
	                child = child.toJS();
	                if (isArr(child)) {
	                    flatEach(child, collectChild, children);
	                } else {
	                    collectChild(child, children);
	                }
	                return;
	            }
	            child = '' + child;
	        }
	        children[children.length] = child;
	    }
	}
	
	function diffVchildren(patches, vnode, newVnode, node, parentContext) {
	    if (!node.vchildren) return; // react-lite hasn't seen this DOM node before
	
	    var childNodes = node.childNodes;
	    var vchildren = node.vchildren;
	
	    var newVchildren = node.vchildren = getFlattenChildren(newVnode);
	    var vchildrenLen = vchildren.length;
	    var newVchildrenLen = newVchildren.length;
	
	    if (vchildrenLen === 0) {
	        if (newVchildrenLen > 0) {
	            for (var i = 0; i < newVchildrenLen; i++) {
	                addItem(patches.creates, {
	                    vnode: newVchildren[i],
	                    parentNode: node,
	                    parentContext: parentContext,
	                    index: i
	                });
	            }
	        }
	        return;
	    } else if (newVchildrenLen === 0) {
	        for (var i = 0; i < vchildrenLen; i++) {
	            addItem(patches.removes, {
	                vnode: vchildren[i],
	                node: childNodes[i]
	            });
	        }
	        return;
	    }
	
	    var updates = Array(newVchildrenLen);
	    var removes = null;
	    var creates = null;
	
	    // isEqual
	    for (var i = 0; i < vchildrenLen; i++) {
	        var _vnode = vchildren[i];
	        for (var j = 0; j < newVchildrenLen; j++) {
	            if (updates[j]) {
	                continue;
	            }
	            var _newVnode = newVchildren[j];
	            if (_vnode === _newVnode) {
	                updates[j] = {
	                    shouldIgnore: shouldIgnoreUpdate(node),
	                    vnode: _vnode,
	                    newVnode: _newVnode,
	                    node: childNodes[i],
	                    parentContext: parentContext,
	                    index: j
	                };
	                vchildren[i] = null;
	                break;
	            }
	        }
	    }
	
	    // isSimilar
	    for (var i = 0; i < vchildrenLen; i++) {
	        var _vnode2 = vchildren[i];
	        if (_vnode2 === null) {
	            continue;
	        }
	        var shouldRemove = true;
	        for (var j = 0; j < newVchildrenLen; j++) {
	            if (updates[j]) {
	                continue;
	            }
	            var _newVnode2 = newVchildren[j];
	            if (_newVnode2.type === _vnode2.type && _newVnode2.key === _vnode2.key && _newVnode2.refs === _vnode2.refs) {
	                updates[j] = {
	                    vnode: _vnode2,
	                    newVnode: _newVnode2,
	                    node: childNodes[i],
	                    parentContext: parentContext,
	                    index: j
	                };
	                shouldRemove = false;
	                break;
	            }
	        }
	        if (shouldRemove) {
	            if (!removes) {
	                removes = [];
	            }
	            addItem(removes, {
	                vnode: _vnode2,
	                node: childNodes[i]
	            });
	        }
	    }
	
	    for (var i = 0; i < newVchildrenLen; i++) {
	        var item = updates[i];
	        if (!item) {
	            if (!creates) {
	                creates = [];
	            }
	            addItem(creates, {
	                vnode: newVchildren[i],
	                parentNode: node,
	                parentContext: parentContext,
	                index: i
	            });
	        } else if (item.vnode.vtype === VELEMENT) {
	            diffVchildren(patches, item.vnode, item.newVnode, item.node, item.parentContext);
	        }
	    }
	
	    if (removes) {
	        addItem(patches.removes, removes);
	    }
	    if (creates) {
	        addItem(patches.creates, creates);
	    }
	    addItem(patches.updates, updates);
	}
	
	function updateVelem(velem, newVelem, node) {
	    var isCustomComponent = velem.type.indexOf('-') >= 0 || velem.props.is != null;
	    patchProps(node, velem.props, newVelem.props, isCustomComponent);
	    if (velem.ref !== newVelem.ref) {
	        detachRef(velem.refs, velem.ref, node);
	        attachRef(newVelem.refs, newVelem.ref, node);
	    }
	    return node;
	}
	
	function destroyVelem(velem, node) {
	    var props = velem.props;
	    var vchildren = node.vchildren;
	    var childNodes = node.childNodes;
	
	    if (vchildren) {
	        for (var i = 0, len = vchildren.length; i < len; i++) {
	            destroyVnode(vchildren[i], childNodes[i]);
	        }
	    }
	    detachRef(velem.refs, velem.ref, node);
	    node.eventStore = node.vchildren = null;
	}
	
	function initVstateless(vstateless, parentContext, namespaceURI) {
	    var vnode = renderVstateless(vstateless, parentContext);
	    var node = initVnode(vnode, parentContext, namespaceURI);
	    node.cache = node.cache || {};
	    node.cache[vstateless.uid] = vnode;
	    return node;
	}
	
	function updateVstateless(vstateless, newVstateless, node, parentContext) {
	    var uid = vstateless.uid;
	    var vnode = node.cache[uid];
	    delete node.cache[uid];
	    var newVnode = renderVstateless(newVstateless, parentContext);
	    var newNode = compareTwoVnodes(vnode, newVnode, node, parentContext);
	    newNode.cache = newNode.cache || {};
	    newNode.cache[newVstateless.uid] = newVnode;
	    if (newNode !== node) {
	        syncCache(newNode.cache, node.cache, newNode);
	    }
	    return newNode;
	}
	
	function destroyVstateless(vstateless, node) {
	    var uid = vstateless.uid;
	    var vnode = node.cache[uid];
	    delete node.cache[uid];
	    destroyVnode(vnode, node);
	}
	
	function renderVstateless(vstateless, parentContext) {
	    var factory = vstateless.type;
	    var props = vstateless.props;
	
	    var componentContext = getContextByTypes(parentContext, factory.contextTypes);
	    var vnode = factory(props, componentContext);
	    if (vnode && vnode.render) {
	        vnode = vnode.render();
	    }
	    if (vnode === null || vnode === false) {
	        vnode = createVnode(VCOMMENT);
	    } else if (!vnode || !vnode.vtype) {
	        throw new Error('@' + factory.name + '#render:You may have returned undefined, an array or some other invalid object');
	    }
	    return vnode;
	}
	
	function initVcomponent(vcomponent, parentContext, namespaceURI) {
	    var Component = vcomponent.type;
	    var props = vcomponent.props;
	    var uid = vcomponent.uid;
	
	    var componentContext = getContextByTypes(parentContext, Component.contextTypes);
	    var component = new Component(props, componentContext);
	    var updater = component.$updater;
	    var cache = component.$cache;
	
	    cache.parentContext = parentContext;
	    updater.isPending = true;
	    component.props = component.props || props;
	    component.context = component.context || componentContext;
	    if (component.componentWillMount) {
	        component.componentWillMount();
	        component.state = updater.getState();
	    }
	    var vnode = renderComponent(component);
	    var node = initVnode(vnode, getChildContext(component, parentContext), namespaceURI);
	    node.cache = node.cache || {};
	    node.cache[uid] = component;
	    cache.vnode = vnode;
	    cache.node = node;
	    cache.isMounted = true;
	    addItem(pendingComponents, component);
	
	    if (vcomponent.ref != null) {
	        addItem(pendingRefs, vcomponent);
	        addItem(pendingRefs, component);
	    }
	
	    return node;
	}
	
	function updateVcomponent(vcomponent, newVcomponent, node, parentContext) {
	    var uid = vcomponent.uid;
	    var component = node.cache[uid];
	    var updater = component.$updater;
	    var cache = component.$cache;
	    var Component = newVcomponent.type;
	    var nextProps = newVcomponent.props;
	
	    var componentContext = getContextByTypes(parentContext, Component.contextTypes);
	    delete node.cache[uid];
	    node.cache[newVcomponent.uid] = component;
	    cache.parentContext = parentContext;
	    if (component.componentWillReceiveProps) {
	        var needToggleIsPending = !updater.isPending;
	        if (needToggleIsPending) updater.isPending = true;
	        component.componentWillReceiveProps(nextProps, componentContext);
	        if (needToggleIsPending) updater.isPending = false;
	    }
	
	    if (vcomponent.ref !== newVcomponent.ref) {
	        detachRef(vcomponent.refs, vcomponent.ref, component);
	        attachRef(newVcomponent.refs, newVcomponent.ref, component);
	    }
	
	    updater.emitUpdate(nextProps, componentContext);
	
	    return cache.node;
	}
	
	function destroyVcomponent(vcomponent, node) {
	    var uid = vcomponent.uid;
	    var component = node.cache[uid];
	    var cache = component.$cache;
	    delete node.cache[uid];
	    detachRef(vcomponent.refs, vcomponent.ref, component);
	    component.setState = component.forceUpdate = noop;
	    if (component.componentWillUnmount) {
	        component.componentWillUnmount();
	    }
	    destroyVnode(cache.vnode, node);
	    delete component.setState;
	    cache.isMounted = false;
	    cache.node = cache.parentContext = cache.vnode = component.refs = component.context = null;
	}
	
	function getContextByTypes(curContext, contextTypes) {
	    var context = {};
	    if (!contextTypes || !curContext) {
	        return context;
	    }
	    for (var key in contextTypes) {
	        if (contextTypes.hasOwnProperty(key)) {
	            context[key] = curContext[key];
	        }
	    }
	    return context;
	}
	
	function renderComponent(component, parentContext) {
	    refs = component.refs;
	    var vnode = component.render();
	    if (vnode === null || vnode === false) {
	        vnode = createVnode(VCOMMENT);
	    } else if (!vnode || !vnode.vtype) {
	        throw new Error('@' + component.constructor.name + '#render:You may have returned undefined, an array or some other invalid object');
	    }
	    refs = null;
	    return vnode;
	}
	
	function getChildContext(component, parentContext) {
	    if (component.getChildContext) {
	        var curContext = component.getChildContext();
	        if (curContext) {
	            parentContext = extend(extend({}, parentContext), curContext);
	        }
	    }
	    return parentContext;
	}
	
	var pendingComponents = [];
	function clearPendingComponents() {
	    var len = pendingComponents.length;
	    if (!len) {
	        return;
	    }
	    var components = pendingComponents;
	    pendingComponents = [];
	    var i = -1;
	    while (len--) {
	        var component = components[++i];
	        var updater = component.$updater;
	        if (component.componentDidMount) {
	            component.componentDidMount();
	        }
	        updater.isPending = false;
	        updater.emitUpdate();
	    }
	}
	
	var pendingRefs = [];
	function clearPendingRefs() {
	    var len = pendingRefs.length;
	    if (!len) {
	        return;
	    }
	    var list = pendingRefs;
	    pendingRefs = [];
	    for (var i = 0; i < len; i += 2) {
	        var vnode = list[i];
	        var refValue = list[i + 1];
	        attachRef(vnode.refs, vnode.ref, refValue);
	    }
	}
	
	function clearPending() {
	    clearPendingRefs();
	    clearPendingComponents();
	}
	
	function compareTwoVnodes(vnode, newVnode, node, parentContext) {
	    var newNode = node;
	    if (newVnode == null) {
	        // remove
	        destroyVnode(vnode, node);
	        node.parentNode.removeChild(node);
	    } else if (vnode.type !== newVnode.type || vnode.key !== newVnode.key) {
	        // replace
	        destroyVnode(vnode, node);
	        newNode = initVnode(newVnode, parentContext, node.namespaceURI);
	        node.parentNode.replaceChild(newNode, node);
	    } else if (vnode !== newVnode || parentContext) {
	        // same type and same key -> update
	        newNode = updateVnode(vnode, newVnode, node, parentContext);
	    }
	    return newNode;
	}
	
	function getDOMNode() {
	    return this;
	}
	
	function attachRef(refs, refKey, refValue) {
	    if (refKey == null || !refValue) {
	        return;
	    }
	    if (refValue.nodeName && !refValue.getDOMNode) {
	        // support react v0.13 style: this.refs.myInput.getDOMNode()
	        refValue.getDOMNode = getDOMNode;
	    }
	    if (isFn(refKey)) {
	        refKey(refValue);
	    } else if (refs) {
	        refs[refKey] = refValue;
	    }
	}
	
	function detachRef(refs, refKey, refValue) {
	    if (refKey == null) {
	        return;
	    }
	    if (isFn(refKey)) {
	        refKey(null);
	    } else if (refs && refs[refKey] === refValue) {
	        delete refs[refKey];
	    }
	}
	
	function syncCache(cache, oldCache, node) {
	    for (var key in oldCache) {
	        if (!oldCache.hasOwnProperty(key)) {
	            continue;
	        }
	        var value = oldCache[key];
	        cache[key] = value;
	
	        // is component, update component.$cache.node
	        if (value.forceUpdate) {
	            value.$cache.node = node;
	        }
	    }
	}
	
	function shouldIgnoreUpdate(node) {
	    var vchildren = node.vchildren;
	    var children = node.children;
	
	    if (vchildren) {
	        for (var i = 0; i < vchildren.length; i++) {
	            var vchild = vchildren[i];
	            if (vchild.vtype === VCOMPONENT || vchild.vtype === VSTATELESS) {
	                if (vchild.type.contextTypes) {
	                    return false;
	                }
	            }
	        }
	    }
	
	    if (children) {
	        for (var i = 0; i < children.length; i++) {
	            if (!shouldIgnoreUpdate(children[i])) {
	                return false;
	            }
	        }
	    }
	
	    return true;
	}
	
	var updateQueue = {
		updaters: [],
		isPending: false,
		add: function add(updater) {
			addItem(this.updaters, updater);
		},
		batchUpdate: function batchUpdate() {
			if (this.isPending) {
				return;
			}
			this.isPending = true;
			/*
	   each updater.update may add new updater to updateQueue
	   clear them with a loop
	   event bubbles from bottom-level to top-level
	   reverse the updater order can merge some props and state and reduce the refresh times
	   see Updater.update method below to know why
	  */
			var updaters = this.updaters;
	
			var updater = undefined;
			while (updater = updaters.pop()) {
				updater.updateComponent();
			}
			this.isPending = false;
		}
	};
	
	function Updater(instance) {
		this.instance = instance;
		this.pendingStates = [];
		this.pendingCallbacks = [];
		this.isPending = false;
		this.nextProps = this.nextContext = null;
		this.clearCallbacks = this.clearCallbacks.bind(this);
	}
	
	Updater.prototype = {
		emitUpdate: function emitUpdate(nextProps, nextContext) {
			this.nextProps = nextProps;
			this.nextContext = nextContext;
			// receive nextProps!! should update immediately
			nextProps || !updateQueue.isPending ? this.updateComponent() : updateQueue.add(this);
		},
		updateComponent: function updateComponent() {
			var instance = this.instance;
			var pendingStates = this.pendingStates;
			var nextProps = this.nextProps;
			var nextContext = this.nextContext;
	
			if (nextProps || pendingStates.length > 0) {
				nextProps = nextProps || instance.props;
				nextContext = nextContext || instance.context;
				this.nextProps = this.nextContext = null;
				// merge the nextProps and nextState and update by one time
				shouldUpdate(instance, nextProps, this.getState(), nextContext, this.clearCallbacks);
			}
		},
		addState: function addState(nextState) {
			if (nextState) {
				addItem(this.pendingStates, nextState);
				if (!this.isPending) {
					this.emitUpdate();
				}
			}
		},
		replaceState: function replaceState(nextState) {
			var pendingStates = this.pendingStates;
	
			pendingStates.pop();
			// push special params to point out should replace state
			addItem(pendingStates, [nextState]);
		},
		getState: function getState() {
			var instance = this.instance;
			var pendingStates = this.pendingStates;
			var state = instance.state;
			var props = instance.props;
	
			if (pendingStates.length) {
				state = extend({}, state);
				pendingStates.forEach(function (nextState) {
					var isReplace = isArr(nextState);
					if (isReplace) {
						nextState = nextState[0];
					}
					if (isFn(nextState)) {
						nextState = nextState.call(instance, state, props);
					}
					// replace state
					if (isReplace) {
						state = extend({}, nextState);
					} else {
						extend(state, nextState);
					}
				});
				pendingStates.length = 0;
			}
			return state;
		},
		clearCallbacks: function clearCallbacks() {
			var pendingCallbacks = this.pendingCallbacks;
			var instance = this.instance;
	
			if (pendingCallbacks.length > 0) {
				this.pendingCallbacks = [];
				pendingCallbacks.forEach(function (callback) {
					return callback.call(instance);
				});
			}
		},
		addCallback: function addCallback(callback) {
			if (isFn(callback)) {
				addItem(this.pendingCallbacks, callback);
			}
		}
	};
	function Component(props, context) {
		this.$updater = new Updater(this);
		this.$cache = { isMounted: false };
		this.props = props;
		this.state = {};
		this.refs = {};
		this.context = context;
	}
	
	var ReactComponentSymbol = {};
	
	Component.prototype = {
		constructor: Component,
		isReactComponent: ReactComponentSymbol,
		// getChildContext: _.noop,
		// componentWillUpdate: _.noop,
		// componentDidUpdate: _.noop,
		// componentWillReceiveProps: _.noop,
		// componentWillMount: _.noop,
		// componentDidMount: _.noop,
		// componentWillUnmount: _.noop,
		// shouldComponentUpdate(nextProps, nextState) {
		// 	return true
		// },
		forceUpdate: function forceUpdate(callback) {
			var $updater = this.$updater;
			var $cache = this.$cache;
			var props = this.props;
			var state = this.state;
			var context = this.context;
	
			if (!$cache.isMounted) {
				return;
			}
			// if updater is pending, add state to trigger nexttick update
			if ($updater.isPending) {
				$updater.addState(state);
				return;
			}
			var nextProps = $cache.props || props;
			var nextState = $cache.state || state;
			var nextContext = $cache.context || context;
			var parentContext = $cache.parentContext;
			var node = $cache.node;
			var vnode = $cache.vnode;
			$cache.props = $cache.state = $cache.context = null;
			$updater.isPending = true;
			if (this.componentWillUpdate) {
				this.componentWillUpdate(nextProps, nextState, nextContext);
			}
			this.state = nextState;
			this.props = nextProps;
			this.context = nextContext;
			var newVnode = renderComponent(this);
			var newNode = compareTwoVnodes(vnode, newVnode, node, getChildContext(this, parentContext));
			if (newNode !== node) {
				newNode.cache = newNode.cache || {};
				syncCache(newNode.cache, node.cache, newNode);
			}
			$cache.vnode = newVnode;
			$cache.node = newNode;
			clearPending();
			if (this.componentDidUpdate) {
				this.componentDidUpdate(props, state, context);
			}
			if (callback) {
				callback.call(this);
			}
			$updater.isPending = false;
			$updater.emitUpdate();
		},
		setState: function setState(nextState, callback) {
			var $updater = this.$updater;
	
			$updater.addCallback(callback);
			$updater.addState(nextState);
		},
		replaceState: function replaceState(nextState, callback) {
			var $updater = this.$updater;
	
			$updater.addCallback(callback);
			$updater.replaceState(nextState);
		},
		getDOMNode: function getDOMNode() {
			var node = this.$cache.node;
			return node && node.nodeName === '#comment' ? null : node;
		},
		isMounted: function isMounted() {
			return this.$cache.isMounted;
		}
	};
	
	function shouldUpdate(component, nextProps, nextState, nextContext, callback) {
		var shouldComponentUpdate = true;
		if (component.shouldComponentUpdate) {
			shouldComponentUpdate = component.shouldComponentUpdate(nextProps, nextState, nextContext);
		}
		if (shouldComponentUpdate === false) {
			component.props = nextProps;
			component.state = nextState;
			component.context = nextContext || {};
			return;
		}
		var cache = component.$cache;
		cache.props = nextProps;
		cache.state = nextState;
		cache.context = nextContext || {};
		component.forceUpdate(callback);
	}
	
	// event config
	var unbubbleEvents = {
	    /**
	     * should not bind mousemove in document scope
	     * even though mousemove event can bubble
	     */
	    onmousemove: 1,
	    ontouchmove: 1,
	    onmouseleave: 1,
	    onmouseenter: 1,
	    onload: 1,
	    onunload: 1,
	    onscroll: 1,
	    onfocus: 1,
	    onblur: 1,
	    onrowexit: 1,
	    onbeforeunload: 1,
	    onstop: 1,
	    ondragdrop: 1,
	    ondragenter: 1,
	    ondragexit: 1,
	    ondraggesture: 1,
	    ondragover: 1,
	    oncontextmenu: 1,
	    onerror: 1,
	
	    // media event
	    onabort: 1,
	    oncanplay: 1,
	    oncanplaythrough: 1,
	    ondurationchange: 1,
	    onemptied: 1,
	    onended: 1,
	    onloadeddata: 1,
	    onloadedmetadata: 1,
	    onloadstart: 1,
	    onencrypted: 1,
	    onpause: 1,
	    onplay: 1,
	    onplaying: 1,
	    onprogress: 1,
	    onratechange: 1,
	    onseeking: 1,
	    onseeked: 1,
	    onstalled: 1,
	    onsuspend: 1,
	    ontimeupdate: 1,
	    onvolumechange: 1,
	    onwaiting: 1
	};
	
	function getEventName(key) {
	    if (key === 'onDoubleClick') {
	        key = 'ondblclick';
	    } else if (key === 'onTouchTap') {
	        key = 'onclick';
	    }
	
	    return key.toLowerCase();
	}
	
	// Mobile Safari does not fire properly bubble click events on
	// non-interactive elements, which means delegated click listeners do not
	// fire. The workaround for this bug involves attaching an empty click
	// listener on the target node.
	var inMobile = ('ontouchstart' in document);
	var emptyFunction = function emptyFunction() {};
	var ON_CLICK_KEY = 'onclick';
	
	var eventTypes = {};
	
	function addEvent(elem, eventType, listener) {
	    eventType = getEventName(eventType);
	
	    var eventStore = elem.eventStore || (elem.eventStore = {});
	    eventStore[eventType] = listener;
	
	    if (unbubbleEvents[eventType] === 1) {
	        elem[eventType] = dispatchUnbubbleEvent;
	        return;
	    } else if (!eventTypes[eventType]) {
	        // onclick -> click
	        document.addEventListener(eventType.substr(2), dispatchEvent, false);
	        eventTypes[eventType] = true;
	    }
	
	    if (inMobile && eventType === ON_CLICK_KEY) {
	        elem.addEventListener('click', emptyFunction, false);
	        return;
	    }
	
	    var nodeName = elem.nodeName;
	
	    if (eventType === 'onchange' && supportInputEvent(elem)) {
	        addEvent(elem, 'oninput', listener);
	    }
	}
	
	function removeEvent(elem, eventType) {
	    eventType = getEventName(eventType);
	
	    var eventStore = elem.eventStore || (elem.eventStore = {});
	    delete eventStore[eventType];
	
	    if (unbubbleEvents[eventType] === 1) {
	        elem[eventType] = null;
	        return;
	    } else if (inMobile && eventType === ON_CLICK_KEY) {
	        elem.removeEventListener('click', emptyFunction, false);
	        return;
	    }
	
	    var nodeName = elem.nodeName;
	
	    if (eventType === 'onchange' && supportInputEvent(elem)) {
	        delete eventStore['oninput'];
	    }
	}
	
	function dispatchEvent(event) {
	    var target = event.target;
	    var type = event.type;
	
	    var eventType = 'on' + type;
	    var syntheticEvent = undefined;
	
	    updateQueue.isPending = true;
	    while (target) {
	        var _target = target;
	        var eventStore = _target.eventStore;
	
	        var listener = eventStore && eventStore[eventType];
	        if (!listener) {
	            target = target.parentNode;
	            continue;
	        }
	        if (!syntheticEvent) {
	            syntheticEvent = createSyntheticEvent(event);
	        }
	        syntheticEvent.currentTarget = target;
	        listener.call(target, syntheticEvent);
	        if (syntheticEvent.$cancelBubble) {
	            break;
	        }
	        target = target.parentNode;
	    }
	    updateQueue.isPending = false;
	    updateQueue.batchUpdate();
	}
	
	function dispatchUnbubbleEvent(event) {
	    var target = event.currentTarget || event.target;
	    var eventType = 'on' + event.type;
	    var syntheticEvent = createSyntheticEvent(event);
	
	    syntheticEvent.currentTarget = target;
	    updateQueue.isPending = true;
	
	    var eventStore = target.eventStore;
	
	    var listener = eventStore && eventStore[eventType];
	    if (listener) {
	        listener.call(target, syntheticEvent);
	    }
	
	    updateQueue.isPending = false;
	    updateQueue.batchUpdate();
	}
	
	function createSyntheticEvent(nativeEvent) {
	    var syntheticEvent = {};
	    var cancelBubble = function cancelBubble() {
	        return syntheticEvent.$cancelBubble = true;
	    };
	    syntheticEvent.nativeEvent = nativeEvent;
	    syntheticEvent.persist = noop;
	    for (var key in nativeEvent) {
	        if (typeof nativeEvent[key] !== 'function') {
	            syntheticEvent[key] = nativeEvent[key];
	        } else if (key === 'stopPropagation' || key === 'stopImmediatePropagation') {
	            syntheticEvent[key] = cancelBubble;
	        } else {
	            syntheticEvent[key] = nativeEvent[key].bind(nativeEvent);
	        }
	    }
	    return syntheticEvent;
	}
	
	function supportInputEvent(elem) {
	    var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName !== 'select' && !(nodeName === 'input' && elem.type === 'file');
	}
	
	function setStyle(elemStyle, styles) {
	    for (var styleName in styles) {
	        if (styles.hasOwnProperty(styleName)) {
	            setStyleValue(elemStyle, styleName, styles[styleName]);
	        }
	    }
	}
	
	function removeStyle(elemStyle, styles) {
	    for (var styleName in styles) {
	        if (styles.hasOwnProperty(styleName)) {
	            elemStyle[styleName] = '';
	        }
	    }
	}
	
	function patchStyle(elemStyle, style, newStyle) {
	    if (style === newStyle) {
	        return;
	    }
	    if (!newStyle && style) {
	        removeStyle(elemStyle, style);
	        return;
	    } else if (newStyle && !style) {
	        setStyle(elemStyle, newStyle);
	        return;
	    }
	
	    for (var key in style) {
	        if (newStyle.hasOwnProperty(key)) {
	            if (newStyle[key] !== style[key]) {
	                setStyleValue(elemStyle, key, newStyle[key]);
	            }
	        } else {
	            elemStyle[key] = '';
	        }
	    }
	    for (var key in newStyle) {
	        if (!style.hasOwnProperty(key)) {
	            setStyleValue(elemStyle, key, newStyle[key]);
	        }
	    }
	}
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	var isUnitlessNumber = {
	    animationIterationCount: 1,
	    borderImageOutset: 1,
	    borderImageSlice: 1,
	    borderImageWidth: 1,
	    boxFlex: 1,
	    boxFlexGroup: 1,
	    boxOrdinalGroup: 1,
	    columnCount: 1,
	    flex: 1,
	    flexGrow: 1,
	    flexPositive: 1,
	    flexShrink: 1,
	    flexNegative: 1,
	    flexOrder: 1,
	    gridRow: 1,
	    gridColumn: 1,
	    fontWeight: 1,
	    lineClamp: 1,
	    lineHeight: 1,
	    opacity: 1,
	    order: 1,
	    orphans: 1,
	    tabSize: 1,
	    widows: 1,
	    zIndex: 1,
	    zoom: 1,
	
	    // SVG-related properties
	    fillOpacity: 1,
	    floodOpacity: 1,
	    stopOpacity: 1,
	    strokeDasharray: 1,
	    strokeDashoffset: 1,
	    strokeMiterlimit: 1,
	    strokeOpacity: 1,
	    strokeWidth: 1
	};
	
	function prefixKey(prefix, key) {
	    return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	    prefixes.forEach(function (prefix) {
	        isUnitlessNumber[prefixKey(prefix, prop)] = 1;
	    });
	});
	
	var RE_NUMBER = /^-?\d+(\.\d+)?$/;
	function setStyleValue(elemStyle, styleName, styleValue) {
	
	    if (!isUnitlessNumber[styleName] && RE_NUMBER.test(styleValue)) {
	        elemStyle[styleName] = styleValue + 'px';
	        return;
	    }
	
	    if (styleName === 'float') {
	        styleName = 'cssFloat';
	    }
	
	    if (styleValue == null || typeof styleValue === 'boolean') {
	        styleValue = '';
	    }
	
	    elemStyle[styleName] = styleValue;
	}
	
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\uB7\\u0300-\\u036F\\u203F-\\u2040';
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + ATTRIBUTE_NAME_START_CHAR + '][' + ATTRIBUTE_NAME_CHAR + ']*$');
	
	var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));
	// will merge some data in properties below
	var properties = {};
	
	/**
	 * Mapping from normalized, camelcased property names to a configuration that
	 * specifies how the associated DOM property should be accessed or rendered.
	 */
	var MUST_USE_PROPERTY = 0x1;
	var HAS_BOOLEAN_VALUE = 0x4;
	var HAS_NUMERIC_VALUE = 0x8;
	var HAS_POSITIVE_NUMERIC_VALUE = 0x10 | 0x8;
	var HAS_OVERLOADED_BOOLEAN_VALUE = 0x20;
	
	// html config
	var HTMLDOMPropertyConfig = {
	    props: {
	        /**
	         * Standard Properties
	         */
	        accept: 0,
	        acceptCharset: 0,
	        accessKey: 0,
	        action: 0,
	        allowFullScreen: HAS_BOOLEAN_VALUE,
	        allowTransparency: 0,
	        alt: 0,
	        async: HAS_BOOLEAN_VALUE,
	        autoComplete: 0,
	        autoFocus: HAS_BOOLEAN_VALUE,
	        autoPlay: HAS_BOOLEAN_VALUE,
	        capture: HAS_BOOLEAN_VALUE,
	        cellPadding: 0,
	        cellSpacing: 0,
	        charSet: 0,
	        challenge: 0,
	        checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	        cite: 0,
	        classID: 0,
	        className: 0,
	        cols: HAS_POSITIVE_NUMERIC_VALUE,
	        colSpan: 0,
	        content: 0,
	        contentEditable: 0,
	        contextMenu: 0,
	        controls: HAS_BOOLEAN_VALUE,
	        coords: 0,
	        crossOrigin: 0,
	        data: 0, // For `<object />` acts as `src`.
	        dateTime: 0,
	        'default': HAS_BOOLEAN_VALUE,
	        // not in regular react, they did it in other way
	        defaultValue: MUST_USE_PROPERTY,
	        // not in regular react, they did it in other way
	        defaultChecked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	        defer: HAS_BOOLEAN_VALUE,
	        dir: 0,
	        disabled: HAS_BOOLEAN_VALUE,
	        download: HAS_OVERLOADED_BOOLEAN_VALUE,
	        draggable: 0,
	        encType: 0,
	        form: 0,
	        formAction: 0,
	        formEncType: 0,
	        formMethod: 0,
	        formNoValidate: HAS_BOOLEAN_VALUE,
	        formTarget: 0,
	        frameBorder: 0,
	        headers: 0,
	        height: 0,
	        hidden: HAS_BOOLEAN_VALUE,
	        high: 0,
	        href: 0,
	        hrefLang: 0,
	        htmlFor: 0,
	        httpEquiv: 0,
	        icon: 0,
	        id: 0,
	        inputMode: 0,
	        integrity: 0,
	        is: 0,
	        keyParams: 0,
	        keyType: 0,
	        kind: 0,
	        label: 0,
	        lang: 0,
	        list: 0,
	        loop: HAS_BOOLEAN_VALUE,
	        low: 0,
	        manifest: 0,
	        marginHeight: 0,
	        marginWidth: 0,
	        max: 0,
	        maxLength: 0,
	        media: 0,
	        mediaGroup: 0,
	        method: 0,
	        min: 0,
	        minLength: 0,
	        // Caution; `option.selected` is not updated if `select.multiple` is
	        // disabled with `removeAttribute`.
	        multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	        muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	        name: 0,
	        nonce: 0,
	        noValidate: HAS_BOOLEAN_VALUE,
	        open: HAS_BOOLEAN_VALUE,
	        optimum: 0,
	        pattern: 0,
	        placeholder: 0,
	        poster: 0,
	        preload: 0,
	        profile: 0,
	        radioGroup: 0,
	        readOnly: HAS_BOOLEAN_VALUE,
	        referrerPolicy: 0,
	        rel: 0,
	        required: HAS_BOOLEAN_VALUE,
	        reversed: HAS_BOOLEAN_VALUE,
	        role: 0,
	        rows: HAS_POSITIVE_NUMERIC_VALUE,
	        rowSpan: HAS_NUMERIC_VALUE,
	        sandbox: 0,
	        scope: 0,
	        scoped: HAS_BOOLEAN_VALUE,
	        scrolling: 0,
	        seamless: HAS_BOOLEAN_VALUE,
	        selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	        shape: 0,
	        size: HAS_POSITIVE_NUMERIC_VALUE,
	        sizes: 0,
	        span: HAS_POSITIVE_NUMERIC_VALUE,
	        spellCheck: 0,
	        src: 0,
	        srcDoc: 0,
	        srcLang: 0,
	        srcSet: 0,
	        start: HAS_NUMERIC_VALUE,
	        step: 0,
	        style: 0,
	        summary: 0,
	        tabIndex: 0,
	        target: 0,
	        title: 0,
	        // Setting .type throws on non-<input> tags
	        type: 0,
	        useMap: 0,
	        value: MUST_USE_PROPERTY,
	        width: 0,
	        wmode: 0,
	        wrap: 0,
	
	        /**
	         * RDFa Properties
	         */
	        about: 0,
	        datatype: 0,
	        inlist: 0,
	        prefix: 0,
	        // property is also supported for OpenGraph in meta tags.
	        property: 0,
	        playsInline: HAS_BOOLEAN_VALUE,
	        resource: 0,
	        'typeof': 0,
	        vocab: 0,
	
	        /**
	         * Non-standard Properties
	         */
	        // autoCapitalize and autoCorrect are supported in Mobile Safari for
	        // keyboard hints.
	        autoCapitalize: 0,
	        autoCorrect: 0,
	        // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	        autoSave: 0,
	        // color is for Safari mask-icon link
	        color: 0,
	        // itemProp, itemScope, itemType are for
	        // Microdata support. See http://schema.org/docs/gs.html
	        itemProp: 0,
	        itemScope: HAS_BOOLEAN_VALUE,
	        itemType: 0,
	        // itemID and itemRef are for Microdata support as well but
	        // only specified in the WHATWG spec document. See
	        // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	        itemID: 0,
	        itemRef: 0,
	        // results show looking glass icon and recent searches on input
	        // search fields in WebKit/Blink
	        results: 0,
	        // IE-only attribute that specifies security restrictions on an iframe
	        // as an alternative to the sandbox attribute on IE<10
	        security: 0,
	        // IE-only attribute that controls focus behavior
	        unselectable: 0
	    },
	    attrNS: {},
	    domAttrs: {
	        acceptCharset: 'accept-charset',
	        className: 'class',
	        htmlFor: 'for',
	        httpEquiv: 'http-equiv'
	    },
	    domProps: {}
	};
	
	// svg config
	var xlink = 'http://www.w3.org/1999/xlink';
	var xml = 'http://www.w3.org/XML/1998/namespace';
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	    accentHeight: 'accent-height',
	    accumulate: 0,
	    additive: 0,
	    alignmentBaseline: 'alignment-baseline',
	    allowReorder: 'allowReorder',
	    alphabetic: 0,
	    amplitude: 0,
	    arabicForm: 'arabic-form',
	    ascent: 0,
	    attributeName: 'attributeName',
	    attributeType: 'attributeType',
	    autoReverse: 'autoReverse',
	    azimuth: 0,
	    baseFrequency: 'baseFrequency',
	    baseProfile: 'baseProfile',
	    baselineShift: 'baseline-shift',
	    bbox: 0,
	    begin: 0,
	    bias: 0,
	    by: 0,
	    calcMode: 'calcMode',
	    capHeight: 'cap-height',
	    clip: 0,
	    clipPath: 'clip-path',
	    clipRule: 'clip-rule',
	    clipPathUnits: 'clipPathUnits',
	    colorInterpolation: 'color-interpolation',
	    colorInterpolationFilters: 'color-interpolation-filters',
	    colorProfile: 'color-profile',
	    colorRendering: 'color-rendering',
	    contentScriptType: 'contentScriptType',
	    contentStyleType: 'contentStyleType',
	    cursor: 0,
	    cx: 0,
	    cy: 0,
	    d: 0,
	    decelerate: 0,
	    descent: 0,
	    diffuseConstant: 'diffuseConstant',
	    direction: 0,
	    display: 0,
	    divisor: 0,
	    dominantBaseline: 'dominant-baseline',
	    dur: 0,
	    dx: 0,
	    dy: 0,
	    edgeMode: 'edgeMode',
	    elevation: 0,
	    enableBackground: 'enable-background',
	    end: 0,
	    exponent: 0,
	    externalResourcesRequired: 'externalResourcesRequired',
	    fill: 0,
	    fillOpacity: 'fill-opacity',
	    fillRule: 'fill-rule',
	    filter: 0,
	    filterRes: 'filterRes',
	    filterUnits: 'filterUnits',
	    floodColor: 'flood-color',
	    floodOpacity: 'flood-opacity',
	    focusable: 0,
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    fontSizeAdjust: 'font-size-adjust',
	    fontStretch: 'font-stretch',
	    fontStyle: 'font-style',
	    fontVariant: 'font-variant',
	    fontWeight: 'font-weight',
	    format: 0,
	    from: 0,
	    fx: 0,
	    fy: 0,
	    g1: 0,
	    g2: 0,
	    glyphName: 'glyph-name',
	    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	    glyphOrientationVertical: 'glyph-orientation-vertical',
	    glyphRef: 'glyphRef',
	    gradientTransform: 'gradientTransform',
	    gradientUnits: 'gradientUnits',
	    hanging: 0,
	    horizAdvX: 'horiz-adv-x',
	    horizOriginX: 'horiz-origin-x',
	    ideographic: 0,
	    imageRendering: 'image-rendering',
	    'in': 0,
	    in2: 0,
	    intercept: 0,
	    k: 0,
	    k1: 0,
	    k2: 0,
	    k3: 0,
	    k4: 0,
	    kernelMatrix: 'kernelMatrix',
	    kernelUnitLength: 'kernelUnitLength',
	    kerning: 0,
	    keyPoints: 'keyPoints',
	    keySplines: 'keySplines',
	    keyTimes: 'keyTimes',
	    lengthAdjust: 'lengthAdjust',
	    letterSpacing: 'letter-spacing',
	    lightingColor: 'lighting-color',
	    limitingConeAngle: 'limitingConeAngle',
	    local: 0,
	    markerEnd: 'marker-end',
	    markerMid: 'marker-mid',
	    markerStart: 'marker-start',
	    markerHeight: 'markerHeight',
	    markerUnits: 'markerUnits',
	    markerWidth: 'markerWidth',
	    mask: 0,
	    maskContentUnits: 'maskContentUnits',
	    maskUnits: 'maskUnits',
	    mathematical: 0,
	    mode: 0,
	    numOctaves: 'numOctaves',
	    offset: 0,
	    opacity: 0,
	    operator: 0,
	    order: 0,
	    orient: 0,
	    orientation: 0,
	    origin: 0,
	    overflow: 0,
	    overlinePosition: 'overline-position',
	    overlineThickness: 'overline-thickness',
	    paintOrder: 'paint-order',
	    panose1: 'panose-1',
	    pathLength: 'pathLength',
	    patternContentUnits: 'patternContentUnits',
	    patternTransform: 'patternTransform',
	    patternUnits: 'patternUnits',
	    pointerEvents: 'pointer-events',
	    points: 0,
	    pointsAtX: 'pointsAtX',
	    pointsAtY: 'pointsAtY',
	    pointsAtZ: 'pointsAtZ',
	    preserveAlpha: 'preserveAlpha',
	    preserveAspectRatio: 'preserveAspectRatio',
	    primitiveUnits: 'primitiveUnits',
	    r: 0,
	    radius: 0,
	    refX: 'refX',
	    refY: 'refY',
	    renderingIntent: 'rendering-intent',
	    repeatCount: 'repeatCount',
	    repeatDur: 'repeatDur',
	    requiredExtensions: 'requiredExtensions',
	    requiredFeatures: 'requiredFeatures',
	    restart: 0,
	    result: 0,
	    rotate: 0,
	    rx: 0,
	    ry: 0,
	    scale: 0,
	    seed: 0,
	    shapeRendering: 'shape-rendering',
	    slope: 0,
	    spacing: 0,
	    specularConstant: 'specularConstant',
	    specularExponent: 'specularExponent',
	    speed: 0,
	    spreadMethod: 'spreadMethod',
	    startOffset: 'startOffset',
	    stdDeviation: 'stdDeviation',
	    stemh: 0,
	    stemv: 0,
	    stitchTiles: 'stitchTiles',
	    stopColor: 'stop-color',
	    stopOpacity: 'stop-opacity',
	    strikethroughPosition: 'strikethrough-position',
	    strikethroughThickness: 'strikethrough-thickness',
	    string: 0,
	    stroke: 0,
	    strokeDasharray: 'stroke-dasharray',
	    strokeDashoffset: 'stroke-dashoffset',
	    strokeLinecap: 'stroke-linecap',
	    strokeLinejoin: 'stroke-linejoin',
	    strokeMiterlimit: 'stroke-miterlimit',
	    strokeOpacity: 'stroke-opacity',
	    strokeWidth: 'stroke-width',
	    surfaceScale: 'surfaceScale',
	    systemLanguage: 'systemLanguage',
	    tableValues: 'tableValues',
	    targetX: 'targetX',
	    targetY: 'targetY',
	    textAnchor: 'text-anchor',
	    textDecoration: 'text-decoration',
	    textRendering: 'text-rendering',
	    textLength: 'textLength',
	    to: 0,
	    transform: 0,
	    u1: 0,
	    u2: 0,
	    underlinePosition: 'underline-position',
	    underlineThickness: 'underline-thickness',
	    unicode: 0,
	    unicodeBidi: 'unicode-bidi',
	    unicodeRange: 'unicode-range',
	    unitsPerEm: 'units-per-em',
	    vAlphabetic: 'v-alphabetic',
	    vHanging: 'v-hanging',
	    vIdeographic: 'v-ideographic',
	    vMathematical: 'v-mathematical',
	    values: 0,
	    vectorEffect: 'vector-effect',
	    version: 0,
	    vertAdvY: 'vert-adv-y',
	    vertOriginX: 'vert-origin-x',
	    vertOriginY: 'vert-origin-y',
	    viewBox: 'viewBox',
	    viewTarget: 'viewTarget',
	    visibility: 0,
	    widths: 0,
	    wordSpacing: 'word-spacing',
	    writingMode: 'writing-mode',
	    x: 0,
	    xHeight: 'x-height',
	    x1: 0,
	    x2: 0,
	    xChannelSelector: 'xChannelSelector',
	    xlinkActuate: 'xlink:actuate',
	    xlinkArcrole: 'xlink:arcrole',
	    xlinkHref: 'xlink:href',
	    xlinkRole: 'xlink:role',
	    xlinkShow: 'xlink:show',
	    xlinkTitle: 'xlink:title',
	    xlinkType: 'xlink:type',
	    xmlBase: 'xml:base',
	    xmlns: 0,
	    xmlnsXlink: 'xmlns:xlink',
	    xmlLang: 'xml:lang',
	    xmlSpace: 'xml:space',
	    y: 0,
	    y1: 0,
	    y2: 0,
	    yChannelSelector: 'yChannelSelector',
	    z: 0,
	    zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	    props: {},
	    attrNS: {
	        xlinkActuate: xlink,
	        xlinkArcrole: xlink,
	        xlinkHref: xlink,
	        xlinkRole: xlink,
	        xlinkShow: xlink,
	        xlinkTitle: xlink,
	        xlinkType: xlink,
	        xmlBase: xml,
	        xmlLang: xml,
	        xmlSpace: xml
	    },
	    domAttrs: {},
	    domProps: {}
	};
	
	Object.keys(ATTRS).map(function (key) {
	    SVGDOMPropertyConfig.props[key] = 0;
	    if (ATTRS[key]) {
	        SVGDOMPropertyConfig.domAttrs[key] = ATTRS[key];
	    }
	});
	
	// merge html and svg config into properties
	mergeConfigToProperties(HTMLDOMPropertyConfig);
	mergeConfigToProperties(SVGDOMPropertyConfig);
	
	function mergeConfigToProperties(config) {
	    var
	    // all react/react-lite supporting property names in here
	    props = config.props;
	    var
	    // attributes namespace in here
	    attrNS = config.attrNS;
	    var
	    // propName in props which should use to be dom-attribute in here
	    domAttrs = config.domAttrs;
	    var
	    // propName in props which should use to be dom-property in here
	    domProps = config.domProps;
	
	    for (var propName in props) {
	        if (!props.hasOwnProperty(propName)) {
	            continue;
	        }
	        var propConfig = props[propName];
	        properties[propName] = {
	            attributeName: domAttrs.hasOwnProperty(propName) ? domAttrs[propName] : propName.toLowerCase(),
	            propertyName: domProps.hasOwnProperty(propName) ? domProps[propName] : propName,
	            attributeNamespace: attrNS.hasOwnProperty(propName) ? attrNS[propName] : null,
	            mustUseProperty: checkMask(propConfig, MUST_USE_PROPERTY),
	            hasBooleanValue: checkMask(propConfig, HAS_BOOLEAN_VALUE),
	            hasNumericValue: checkMask(propConfig, HAS_NUMERIC_VALUE),
	            hasPositiveNumericValue: checkMask(propConfig, HAS_POSITIVE_NUMERIC_VALUE),
	            hasOverloadedBooleanValue: checkMask(propConfig, HAS_OVERLOADED_BOOLEAN_VALUE)
	        };
	    }
	}
	
	function checkMask(value, bitmask) {
	    return (value & bitmask) === bitmask;
	}
	
	/**
	 * Sets the value for a property on a node.
	 *
	 * @param {DOMElement} node
	 * @param {string} name
	 * @param {*} value
	 */
	
	function setPropValue(node, name, value) {
	    var propInfo = properties.hasOwnProperty(name) && properties[name];
	    if (propInfo) {
	        // should delete value from dom
	        if (value == null || propInfo.hasBooleanValue && !value || propInfo.hasNumericValue && isNaN(value) || propInfo.hasPositiveNumericValue && value < 1 || propInfo.hasOverloadedBooleanValue && value === false) {
	            removePropValue(node, name);
	        } else if (propInfo.mustUseProperty) {
	            node[propInfo.propertyName] = value;
	        } else {
	            var attributeName = propInfo.attributeName;
	            var namespace = propInfo.attributeNamespace;
	
	            // `setAttribute` with objects becomes only `[object]` in IE8/9,
	            // ('' + value) makes it output the correct toString()-value.
	            if (namespace) {
	                node.setAttributeNS(namespace, attributeName, '' + value);
	            } else if (propInfo.hasBooleanValue || propInfo.hasOverloadedBooleanValue && value === true) {
	                node.setAttribute(attributeName, '');
	            } else {
	                node.setAttribute(attributeName, '' + value);
	            }
	        }
	    } else if (isCustomAttribute(name) && VALID_ATTRIBUTE_NAME_REGEX.test(name)) {
	        if (value == null) {
	            node.removeAttribute(name);
	        } else {
	            node.setAttribute(name, '' + value);
	        }
	    }
	}
	
	/**
	 * Deletes the value for a property on a node.
	 *
	 * @param {DOMElement} node
	 * @param {string} name
	 */
	
	function removePropValue(node, name) {
	    var propInfo = properties.hasOwnProperty(name) && properties[name];
	    if (propInfo) {
	        if (propInfo.mustUseProperty) {
	            var propName = propInfo.propertyName;
	            if (propInfo.hasBooleanValue) {
	                node[propName] = false;
	            } else {
	                node[propName] = '';
	            }
	        } else {
	            node.removeAttribute(propInfo.attributeName);
	        }
	    } else if (isCustomAttribute(name)) {
	        node.removeAttribute(name);
	    }
	}
	
	function updateSelectOptions(select, multiple, propValue) {
	    var selectedValue, i;
	    var options = select.options;
	
	    if (multiple) {
	        select.multiple = true;
	        if (!Array.isArray(propValue)) {
	            throw new Error('The value prop supplied to <select> must be an array if `multiple` is true');
	        }
	        selectedValue = {};
	        for (i = 0; i < propValue.length; i++) {
	            selectedValue['' + propValue[i]] = true;
	        }
	        for (i = 0; i < options.length; i++) {
	            var selected = selectedValue.hasOwnProperty(options[i].value);
	            if (options[i].selected !== selected) {
	                options[i].selected = selected;
	            }
	        }
	    } else {
	        select.multiple = false;
	        if (Array.isArray(propValue)) {
	            throw new Error('The value prop supplied to <select> must be a scalar value if `multiple` is false.');
	        }
	        // Do not set `select.value` as exact behavior isn't consistent across all
	        // browsers for all cases.
	        selectedValue = '' + propValue;
	        for (i = 0; i < options.length; i++) {
	            var option = options[i];
	            if (option.value === selectedValue) {
	                if (!option.selected) {
	                    option.selected = true;
	                }
	            } else {
	                if (option.selected) {
	                    option.selected = false;
	                }
	            }
	        }
	
	        if (options.selectedIndex < 0 && options.length) {
	            options[0].selected = true;
	        }
	    }
	}
	
	function isFn(obj) {
	    return typeof obj === 'function';
	}
	
	var isArr = Array.isArray;
	
	function noop() {}
	
	function identity(obj) {
	    return obj;
	}
	
	function pipe(fn1, fn2) {
	    return function () {
	        fn1.apply(this, arguments);
	        return fn2.apply(this, arguments);
	    };
	}
	
	function addItem(list, item) {
	    list[list.length] = item;
	}
	
	function flatEach(list, iteratee, a) {
	    var len = list.length;
	    var i = -1;
	
	    while (len--) {
	        var item = list[++i];
	        if (isArr(item)) {
	            flatEach(item, iteratee, a);
	        } else {
	            iteratee(item, a);
	        }
	    }
	}
	
	function extend(to, from) {
	    if (!from) {
	        return to;
	    }
	    var keys = Object.keys(from);
	    var i = keys.length;
	    while (i--) {
	        to[keys[i]] = from[keys[i]];
	    }
	    return to;
	}
	
	var uid = 0;
	
	function getUid() {
	    return ++uid;
	}
	
	var EVENT_KEYS = /^on/i;
	
	function setProp(elem, key, value, isCustomComponent) {
	    if (EVENT_KEYS.test(key)) {
	        addEvent(elem, key, value);
	    } else if (key === 'style') {
	        setStyle(elem.style, value);
	    } else if (key === HTML_KEY) {
	        if (value && value.__html != null) {
	            elem.innerHTML = value.__html;
	        }
	    } else if (isCustomComponent) {
	        if (value == null) {
	            elem.removeAttribute(key);
	        } else {
	            elem.setAttribute(key, '' + value);
	        }
	    } else {
	        setPropValue(elem, key, value);
	    }
	}
	
	function removeProp(elem, key, oldValue, isCustomComponent) {
	    if (EVENT_KEYS.test(key)) {
	        removeEvent(elem, key);
	    } else if (key === 'style') {
	        removeStyle(elem.style, oldValue);
	    } else if (key === HTML_KEY) {
	        elem.innerHTML = '';
	    } else if (isCustomComponent) {
	        elem.removeAttribute(key);
	    } else {
	        removePropValue(elem, key);
	    }
	}
	
	function patchProp(elem, key, value, oldValue, isCustomComponent) {
	    if (key === 'value' || key === 'checked') {
	        oldValue = elem[key];
	    }
	    if (value === oldValue) {
	        return;
	    }
	    if (value === undefined) {
	        removeProp(elem, key, oldValue, isCustomComponent);
	        return;
	    }
	    if (key === 'style') {
	        patchStyle(elem.style, oldValue, value);
	    } else {
	        setProp(elem, key, value, isCustomComponent);
	    }
	}
	
	function setProps(elem, props, isCustomComponent) {
	    var isSelect = elem.nodeName === 'SELECT';
	    for (var key in props) {
	        if (key !== 'children') {
	            if (isSelect && (key === 'value' || key === 'defaultValue')) {
	                updateSelectOptions(elem, props.multiple, props[key]);
	            } else {
	                setProp(elem, key, props[key], isCustomComponent);
	            }
	        }
	    }
	}
	
	function patchProps(elem, props, newProps, isCustomComponent) {
	    var isSelect = elem.nodeName === 'SELECT';
	    for (var key in props) {
	        if (key !== 'children') {
	            if (newProps.hasOwnProperty(key)) {
	                if (isSelect && (key === 'value' || key === 'defaultValue')) {
	                    updateSelectOptions(elem, newProps.multiple, newProps[key]);
	                } else {
	                    patchProp(elem, key, newProps[key], props[key], isCustomComponent);
	                }
	            } else {
	                removeProp(elem, key, props[key], isCustomComponent);
	            }
	        }
	    }
	    for (var key in newProps) {
	        if (key !== 'children' && !props.hasOwnProperty(key)) {
	            if (isSelect && (key === 'value' || key === 'defaultValue')) {
	                updateSelectOptions(elem, newProps.multiple, newProps[key]);
	            } else {
	                setProp(elem, key, newProps[key], isCustomComponent);
	            }
	        }
	    }
	}
	
	if (!Object.freeze) {
	    Object.freeze = identity;
	}
	
	function isValidContainer(node) {
		return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	var pendingRendering = {};
	var vnodeStore = {};
	function renderTreeIntoContainer(vnode, container, callback, parentContext) {
		if (!vnode.vtype) {
			throw new Error('cannot render ' + vnode + ' to container');
		}
		if (!isValidContainer(container)) {
			throw new Error('container ' + container + ' is not a DOM element');
		}
		var id = container[COMPONENT_ID] || (container[COMPONENT_ID] = getUid());
		var argsCache = pendingRendering[id];
	
		// component lify cycle method maybe call root rendering
		// should bundle them and render by only one time
		if (argsCache) {
			if (argsCache === true) {
				pendingRendering[id] = argsCache = { vnode: vnode, callback: callback, parentContext: parentContext };
			} else {
				argsCache.vnode = vnode;
				argsCache.parentContext = parentContext;
				argsCache.callback = argsCache.callback ? pipe(argsCache.callback, callback) : callback;
			}
			return;
		}
	
		pendingRendering[id] = true;
		var oldVnode = null;
		var rootNode = null;
		if (oldVnode = vnodeStore[id]) {
			rootNode = compareTwoVnodes(oldVnode, vnode, container.firstChild, parentContext);
		} else {
			rootNode = initVnode(vnode, parentContext, container.namespaceURI);
			var childNode = null;
			while (childNode = container.lastChild) {
				container.removeChild(childNode);
			}
			container.appendChild(rootNode);
		}
		vnodeStore[id] = vnode;
		var isPending = updateQueue.isPending;
		updateQueue.isPending = true;
		clearPending();
		argsCache = pendingRendering[id];
		delete pendingRendering[id];
	
		var result = null;
		if (typeof argsCache === 'object') {
			result = renderTreeIntoContainer(argsCache.vnode, container, argsCache.callback, argsCache.parentContext);
		} else if (vnode.vtype === VELEMENT) {
			result = rootNode;
		} else if (vnode.vtype === VCOMPONENT) {
			result = rootNode.cache[vnode.uid];
		}
	
		if (!isPending) {
			updateQueue.isPending = false;
			updateQueue.batchUpdate();
		}
	
		if (callback) {
			callback.call(result);
		}
	
		return result;
	}
	
	function render(vnode, container, callback) {
		return renderTreeIntoContainer(vnode, container, callback);
	}
	
	function unstable_renderSubtreeIntoContainer(parentComponent, subVnode, container, callback) {
		var context = parentComponent.$cache.parentContext;
		return renderTreeIntoContainer(subVnode, container, callback, context);
	}
	
	function unmountComponentAtNode(container) {
		if (!container.nodeName) {
			throw new Error('expect node');
		}
		var id = container[COMPONENT_ID];
		var vnode = null;
		if (vnode = vnodeStore[id]) {
			destroyVnode(vnode, container.firstChild);
			container.removeChild(container.firstChild);
			delete vnodeStore[id];
			return true;
		}
		return false;
	}
	
	function findDOMNode(node) {
		if (node == null) {
			return null;
		}
		if (node.nodeName) {
			return node;
		}
		var component = node;
		// if component.node equal to false, component must be unmounted
		if (component.getDOMNode && component.$cache.isMounted) {
			return component.getDOMNode();
		}
		throw new Error('findDOMNode can not find Node');
	}
	
	var ReactDOM = Object.freeze({
		render: render,
		unstable_renderSubtreeIntoContainer: unstable_renderSubtreeIntoContainer,
		unmountComponentAtNode: unmountComponentAtNode,
		findDOMNode: findDOMNode
	});
	
	function createElement(type, props, children) {
		var vtype = null;
		if (typeof type === 'string') {
			vtype = VELEMENT;
		} else if (typeof type === 'function') {
			if (type.prototype && type.prototype.isReactComponent) {
				vtype = VCOMPONENT;
			} else {
				vtype = VSTATELESS;
			}
		} else {
			throw new Error('React.createElement: unexpect type [ ' + type + ' ]');
		}
	
		var key = null;
		var ref = null;
		var finalProps = {};
		if (props != null) {
			for (var propKey in props) {
				if (!props.hasOwnProperty(propKey)) {
					continue;
				}
				if (propKey === 'key') {
					if (props.key !== undefined) {
						key = '' + props.key;
					}
				} else if (propKey === 'ref') {
					if (props.ref !== undefined) {
						ref = props.ref;
					}
				} else {
					finalProps[propKey] = props[propKey];
				}
			}
		}
	
		var defaultProps = type.defaultProps;
	
		if (defaultProps) {
			for (var propKey in defaultProps) {
				if (finalProps[propKey] === undefined) {
					finalProps[propKey] = defaultProps[propKey];
				}
			}
		}
	
		var argsLen = arguments.length;
		var finalChildren = children;
	
		if (argsLen > 3) {
			finalChildren = Array(argsLen - 2);
			for (var i = 2; i < argsLen; i++) {
				finalChildren[i - 2] = arguments[i];
			}
		}
	
		if (finalChildren !== undefined) {
			finalProps.children = finalChildren;
		}
	
		return createVnode(vtype, type, finalProps, key, ref);
	}
	
	function isValidElement(obj) {
		return obj != null && !!obj.vtype;
	}
	
	function cloneElement(originElem, props) {
		var type = originElem.type;
		var key = originElem.key;
		var ref = originElem.ref;
	
		var newProps = extend(extend({ key: key, ref: ref }, originElem.props), props);
	
		for (var _len = arguments.length, children = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
			children[_key - 2] = arguments[_key];
		}
	
		var vnode = createElement.apply(undefined, [type, newProps].concat(children));
		if (vnode.ref === originElem.ref) {
			vnode.refs = originElem.refs;
		}
		return vnode;
	}
	
	function createFactory(type) {
		var factory = function factory() {
			for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				args[_key2] = arguments[_key2];
			}
	
			return createElement.apply(undefined, [type].concat(args));
		};
		factory.type = type;
		return factory;
	}
	
	var tagNames = 'a|abbr|address|area|article|aside|audio|b|base|bdi|bdo|big|blockquote|body|br|button|canvas|caption|cite|code|col|colgroup|data|datalist|dd|del|details|dfn|dialog|div|dl|dt|em|embed|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|head|header|hgroup|hr|html|i|iframe|img|input|ins|kbd|keygen|label|legend|li|link|main|map|mark|menu|menuitem|meta|meter|nav|noscript|object|ol|optgroup|option|output|p|param|picture|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|source|span|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|u|ul|var|video|wbr|circle|clipPath|defs|ellipse|g|image|line|linearGradient|mask|path|pattern|polygon|polyline|radialGradient|rect|stop|svg|text|tspan';
	var DOM = {};
	tagNames.split('|').forEach(function (tagName) {
		DOM[tagName] = createFactory(tagName);
	});
	
	var check = function check() {
	    return check;
	};
	check.isRequired = check;
	var PropTypes = {
	    "array": check,
	    "bool": check,
	    "func": check,
	    "number": check,
	    "object": check,
	    "string": check,
	    "any": check,
	    "arrayOf": check,
	    "element": check,
	    "instanceOf": check,
	    "node": check,
	    "objectOf": check,
	    "oneOf": check,
	    "oneOfType": check,
	    "shape": check
	};
	
	function only(children) {
		if (isValidElement(children)) {
			return children;
		}
		throw new Error('expect only one child');
	}
	
	function forEach(children, iteratee, context) {
		if (children == null) {
			return children;
		}
		var index = 0;
		if (isArr(children)) {
			flatEach(children, function (child) {
				// from traverseAllChildrenImpl in react
				var type = typeof child;
				if (type === 'undefined' || type === 'boolean') {
					// All of the above are perceived as null.
					child = null;
				}
	
				iteratee.call(context, child, index++);
			});
		} else {
			// from traverseAllChildrenImpl in react
			var type = typeof children;
			if (type === 'undefined' || type === 'boolean') {
				// All of the above are perceived as null.
				children = null;
			}
			iteratee.call(context, children, index);
		}
	}
	
	function map(children, iteratee, context) {
		if (children == null) {
			return children;
		}
		var store = [];
		var keyMap = {};
		forEach(children, function (child, index) {
			var data = {};
			data.child = iteratee.call(context, child, index) || child;
			data.isEqual = data.child === child;
			var key = data.key = getKey(child, index);
			if (keyMap.hasOwnProperty(key)) {
				keyMap[key] += 1;
			} else {
				keyMap[key] = 0;
			}
			data.index = keyMap[key];
			addItem(store, data);
		});
		var result = [];
		store.forEach(function (_ref) {
			var child = _ref.child;
			var key = _ref.key;
			var index = _ref.index;
			var isEqual = _ref.isEqual;
	
			if (child == null || typeof child === 'boolean') {
				return;
			}
			if (!isValidElement(child) || key == null) {
				addItem(result, child);
				return;
			}
			if (keyMap[key] !== 0) {
				key += ':' + index;
			}
			if (!isEqual) {
				key = escapeUserProvidedKey(child.key || '') + '/' + key;
			}
			child = cloneElement(child, { key: key });
			addItem(result, child);
		});
		return result;
	}
	
	function count(children) {
		var count = 0;
		forEach(children, function () {
			count++;
		});
		return count;
	}
	
	function toArray(children) {
		return map(children, identity) || [];
	}
	
	function getKey(child, index) {
		var key = undefined;
		if (isValidElement(child) && typeof child.key === 'string') {
			key = '.$' + child.key;
		} else {
			key = '.' + index.toString(36);
		}
		return key;
	}
	
	var userProvidedKeyEscapeRegex = /\/(?!\/)/g;
	function escapeUserProvidedKey(text) {
		return ('' + text).replace(userProvidedKeyEscapeRegex, '//');
	}
	
	var Children = Object.freeze({
		only: only,
		forEach: forEach,
		map: map,
		count: count,
		toArray: toArray
	});
	
	function eachMixin(mixins, iteratee) {
		mixins.forEach(function (mixin) {
			if (mixin) {
				if (isArr(mixin.mixins)) {
					eachMixin(mixin.mixins, iteratee);
				}
				iteratee(mixin);
			}
		});
	}
	
	function combineMixinToProto(proto, mixin) {
		for (var key in mixin) {
			if (!mixin.hasOwnProperty(key)) {
				continue;
			}
			var value = mixin[key];
			if (key === 'getInitialState') {
				addItem(proto.$getInitialStates, value);
				continue;
			}
			var curValue = proto[key];
			if (isFn(curValue) && isFn(value)) {
				proto[key] = pipe(curValue, value);
			} else {
				proto[key] = value;
			}
		}
	}
	
	function combineMixinToClass(Component, mixin) {
		if (mixin.propTypes) {
			Component.propTypes = Component.propTypes || {};
			extend(Component.propTypes, mixin.propTypes);
		}
		if (mixin.contextTypes) {
			Component.contextTypes = Component.contextTypes || {};
			extend(Component.contextTypes, mixin.contextTypes);
		}
		extend(Component, mixin.statics);
		if (isFn(mixin.getDefaultProps)) {
			Component.defaultProps = Component.defaultProps || {};
			extend(Component.defaultProps, mixin.getDefaultProps());
		}
	}
	
	function bindContext(obj, source) {
		for (var key in source) {
			if (source.hasOwnProperty(key)) {
				if (isFn(source[key])) {
					obj[key] = source[key].bind(obj);
				}
			}
		}
	}
	
	var Facade = function Facade() {};
	Facade.prototype = Component.prototype;
	
	function getInitialState() {
		var _this = this;
	
		var state = {};
		var setState = this.setState;
		this.setState = Facade;
		this.$getInitialStates.forEach(function (getInitialState) {
			if (isFn(getInitialState)) {
				extend(state, getInitialState.call(_this));
			}
		});
		this.setState = setState;
		return state;
	}
	function createClass(spec) {
		if (!isFn(spec.render)) {
			throw new Error('createClass: spec.render is not function');
		}
		var specMixins = spec.mixins || [];
		var mixins = specMixins.concat(spec);
		spec.mixins = null;
		function Klass(props, context) {
			Component.call(this, props, context);
			this.constructor = Klass;
			spec.autobind !== false && bindContext(this, Klass.prototype);
			this.state = this.getInitialState() || this.state;
		}
		Klass.displayName = spec.displayName;
		var proto = Klass.prototype = new Facade();
		proto.$getInitialStates = [];
		eachMixin(mixins, function (mixin) {
			combineMixinToProto(proto, mixin);
			combineMixinToClass(Klass, mixin);
		});
		proto.getInitialState = getInitialState;
		spec.mixins = specMixins;
		return Klass;
	}
	
	function shallowEqual(objA, objB) {
	    if (objA === objB) {
	        return true;
	    }
	
	    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if (keysA.length !== keysB.length) {
	        return false;
	    }
	
	    // Test for A's keys different from B.
	    for (var i = 0; i < keysA.length; i++) {
	        if (!objB.hasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	            return false;
	        }
	    }
	
	    return true;
	}
	
	function PureComponent(props, context) {
		Component.call(this, props, context);
	}
	
	PureComponent.prototype = Object.create(Component.prototype);
	PureComponent.prototype.constructor = PureComponent;
	PureComponent.prototype.isPureReactComponent = true;
	PureComponent.prototype.shouldComponentUpdate = shallowCompare;
	
	function shallowCompare(nextProps, nextState) {
		return !shallowEqual(this.props, nextProps) || !shallowEqual(this.state, nextState);
	}
	
	var React = extend({
	    version: '0.15.1',
	    cloneElement: cloneElement,
	    isValidElement: isValidElement,
	    createElement: createElement,
	    createFactory: createFactory,
	    Component: Component,
	    PureComponent: PureComponent,
	    createClass: createClass,
	    Children: Children,
	    PropTypes: PropTypes,
	    DOM: DOM
	}, ReactDOM);
	
	React.__SECRET_DOM_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOM;
	
	module.exports = React;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * @license
	 * pull-element.js v1.1.4
	 * (c) 2017 Jade Gu
	 * Released under the MIT License.
	 * https://github.com/Lucifier129/pull-element
	 */
	;(function(global, factory) {
		 true
			? (module.exports = factory())
			: typeof define === 'function' && define.amd
				? define(factory)
				: (global.PullElement = factory())
	})(this, function() {
		'use strict'
	
		function extend(target) {
			var args = arguments
			var argsLen = args.length
			for (var i = 1; i < argsLen; i++) {
				var source = args[i]
				for (var key in source) {
					target[key] = source[key]
				}
			}
			return target
		}
	
		function isNumber(obj) {
			return typeof obj === 'number' && !isNaN(obj)
		}
	
		function isFunction(obj) {
			return typeof obj === 'function'
		}
	
		function getScrollEndingInfo(scroller, isGlobalScroller) {
			var scrollTop, scrollLeft, offsetWidth, offsetHeight
			var scrollWidth = scroller.scrollWidth
			var scrollHeight = scroller.scrollHeight
	
			if (isGlobalScroller) {
				var documentElement = document.documentElement
				var documentBody = document.body
				offsetWidth = documentElement.clientWidth
				offsetHeight = documentElement.clientHeight
				scrollTop = documentBody.scrollTop || documentElement.scrollTop
				scrollLeft = documentBody.scrollLeft || documentElement.scrollLeft
			} else {
				offsetWidth = scroller.offsetWidth
				offsetHeight = scroller.offsetHeight
				scrollTop = scroller.scrollTop
				scrollLeft = scroller.scrollLeft
			}
	
			return {
				isScrollTopEnd: scrollTop <= 0,
				isScrollBottomEnd: offsetHeight + scrollTop >= scrollHeight,
				isScrollLeftEnd: scrollLeft <= 0,
				isScrollRightEnd: offsetWidth + scrollLeft >= scrollWidth
			}
		}
	
		function getElem(elem) {
			return typeof elem === 'string' ? document.querySelector(elem) : elem
		}
	
		function getElems(elems) {
			if (typeof elems === 'string') {
				return Array.prototype.slice.call(document.querySelectorAll(elems))
			} else if (elems.length) {
				return Array.prototype.slice.call(elems)
			} else {
				return [elems]
			}
		}
	
		function addEvent(elem, type, handler, options) {
			elem.addEventListener(type, handler, options)
		}
	
		function removeEvent(elem, type, handler) {
			elem.removeEventListener(type, handler)
		}
	
		function getCoor(event) {
			var targetEvent = event.touches[0]
			return {
				x: targetEvent.clientX,
				y: targetEvent.clientY
			}
		}
	
		function transformValueByDamping(value, damping) {
			if (isFunction(damping)) {
				return damping(value)
			}
			if (isNumber(damping)) {
				return value / damping
			}
			return value
		}
	
		function getTranslateStyle(translateX, translateY) {
			var translateValue =
				'translate(' + translateX + 'px,' + translateY + 'px) translateZ(0)'
			return {
				transform: translateValue,
				webkitTransform: translateValue
			}
		}
	
		// https://developers.google.com/web/updates/2017/01/scrolling-intervention
		var eventHandlerOptions = {
			passive: false
		}
	
		var emptyStyle = {
			transition: '',
			transform: '',
			webkitTransform: '',
			webkitTransition: ''
		}
	
		var emptyTransitionStyle = {
			transition: '',
			webkitTransition: ''
		}
	
		var eventMap = {
			pullDown: 'onPullDown',
			pullUp: 'onPullUp',
			pullRight: 'onPullRight',
			pullLeft: 'onPullLeft'
		}
	
		var propMap = {
			pullDown: 'isScrollTopEnd',
			pullUp: 'isScrollBottomEnd',
			pullRight: 'isScrollLeftEnd',
			pullLeft: 'isScrollRightEnd'
		}
	
		var defaultOffsetState = {
			action: '',
			axis: '',
			translateX: 0,
			translateY: 0
		}
	
		var defaultState = extend(
			{
				isScrollTopEnd: true,
				isScrollLeftEnd: true,
				isScrollBottomEnd: true,
				isScrollRightEnd: true,
				clientX: 0,
				clientY: 0
			},
			defaultOffsetState
		)
	
		var defaultOptions = {
			target: 'body',
			scroller: '',
			trigger: '',
			damping: 1.6,
			wait: true,
			pullUp: false,
			pullDown: false,
			pullLeft: false,
			pullRight: false,
			detectScroll: false,
			detectScrollOnStart: false,
			detectBoundary: false,
			stopPropagation: false,
			drag: false,
			transitionProperty: 'transform',
			transitionDuration: '0.3s',
			transitionTimingFunction: 'ease-out'
		}
	
		var isSupportPromise = typeof Promise === 'function'
	
		function PullElement(options) {
			this.options = extend({}, defaultOptions, options)
			this.state = extend({}, defaultState)
			this.target = null
			this.scroller = null
			this.trigger = null
			this.transitionStyle = null
			this.isTouching = false
			this.isPreventDefault = false
			this.isWaiting = false
			this.isGlobalScroller = false
			this.transitionDuration = 0
			this.handleTouchStart = this.handleTouchStart.bind(this)
			this.handleTouchMove = this.handleTouchMove.bind(this)
			this.handleTouchEnd = this.handleTouchEnd.bind(this)
		}
	
		extend(PullElement.prototype, {
			init: function() {
				var options = this.options
				var target = getElem(options.target)
				var scroller = options.scroller ? getElem(options.scroller) : target
				var trigger = options.trigger ? getElems(options.trigger) : [target]
	
				this.target = target
				this.scroller = scroller
				this.trigger = trigger
				this.isGlobalScroller =
					scroller === document.body ||
					scroller === window ||
					scroller === document.documentElement
				this.transitionStyle = {
					transitionProperty: options.transitionProperty,
					transitionDuration: options.transitionDuration,
					transitionTimingFunction: options.transitionTimingFunction,
					webkitTransitionProperty: options.transitionProperty,
					webkitTransitionDuration: options.transitionDuration,
					webkitTransitionTimingFunction: options.transitionTimingFunction
				}
				/**
				 * in some browser, transitionend dose'nt work as expected
				 * use setTimeout instead
				 */
				var transitionDuration = Number(
					options.transitionDuration.replace(/[^.\d]+/g, '')
				)
	
				// transform 1s to 1000ms
				if (/[\d\.]+s$/.test(options.transitionDuration)) {
					transitionDuration = transitionDuration * 1000
				}
				this.transitionDuration = transitionDuration
				this.enable()
			},
			destroy: function() {
				this.disable()
			},
			setTranslate: function(translateX, translateY) {
				var state = this.state
				state.translateX = translateX
				state.translateY = translateY
				extend(
					this.target.style,
					emptyTransitionStyle,
					getTranslateStyle(translateX, translateY)
				)
			},
			animateTo: function(translateX, translateY, callback) {
				var state = this.state
				var target = this.target
				var transitionDuration = this.transitionDuration
				var transitionStyle = this.transitionStyle
				var translateStyle = getTranslateStyle(translateX, translateY)
	
				state.translateX = translateX
				state.translateY = translateY
	
				var createTransitionEndHandler = function(callback) {
					extend(target.style, transitionStyle, translateStyle)
					setTimeout(callback, transitionDuration)
				}
	
				if (isSupportPromise) {
					return new Promise(createTransitionEndHandler).then(callback)
				}
				createTransitionEndHandler(callback)
			},
			animateToOrigin: function(callback) {
				var context = this
				var finalCallback = function() {
					extend(context.target.style, emptyStyle)
					extend(context.state, defaultOffsetState)
					context.isWaiting = false
					callback && callback()
				}
				return this.animateTo(0, 0, finalCallback)
			},
			enable: function() {
				for (var i = 0; i < this.trigger.length; i++) {
					addEvent(this.trigger[i], 'touchstart', this.handleTouchStart)
				}
				
				addEvent(document, 'touchmove', this.handleTouchMove, eventHandlerOptions)
				addEvent(document, 'touchend', this.handleTouchEnd)
				addEvent(document, 'touchcancel', this.handleTouchEnd)
			},
			disable: function() {
				for (var i = 0; i < this.trigger.length; i++) {
					removeEvent(this.trigger[i], 'touchstart', this.handleTouchStart)
				}
				
				removeEvent(
					document,
					'touchmove',
					this.handleTouchMove,
					eventHandlerOptions
				)
				removeEvent(document, 'touchend', this.handleTouchEnd)
				removeEvent(document, 'touchcancel', this.handleTouchEnd)
			},
			preventDefault: function() {
				this.isPreventDefault = true
			},
			getScrollInfo: function() {
				return getScrollEndingInfo(this.scroller, this.isGlobalScroller)
			},
			isActiveAction: function(action) {
				var options = this.options
				var eventName = eventMap[action]
				return options[eventName] || options[eventName + 'End'] || options[action]
			},
			emit: function(eventName, data) {
				var listener = this.options[eventName]
				if (isFunction(listener)) {
					listener.call(this, data)
				}
			},
			detectBoundary: function(action, deltaX, deltaY, translateX, translateY) {
				var isBoundary =  false
	
				if (action === 'pullDown') {
					if (translateY <= 0 && deltaY <= 0) {
						isBoundary = true
					}
				} else if (action === 'pullUp') {
					if (translateY >= 0 && deltaY >= 0) {
						isBoundary = true
					}
				} else if (action == 'pullLeft') {
					if (translateX >= 0 && deltaX >= 0) {
						isBoundary = true
					}
				} else if (action === 'pullRight') {
					if (translateX <= 0 && deltaX <= 0) {
						isBoundary = true
					}
				}
	
				if (isBoundary) {
					this.handleTouchEnd()
					return true
				}
	
				return false
			},
			handleTouchStart: function(event) {
				if (this.isTouching || this.isWaiting) {
					return
				}
				var options = this.options
				var coor = getCoor(event)
	
				extend(this.state, {
					clientX: coor.x,
					clientY: coor.y,
					axis: '',
					action: ''
				})
	
				if (options.detectScroll || options.detectScrollOnStart) {
					extend(this.state, this.getScrollInfo())
				}
	
				if (options.stopPropagation) {
					event.stopPropagation()
				}
	
				this.isTouching = true
			},
			handleTouchMove: function(event) {
				if (!this.isTouching) {
					return
				}
				var coor = getCoor(event)
				var options = this.options
				var state = this.state
				var clientX = coor.x
				var clientY = coor.y
				var deltaX = clientX - state.clientX
				var deltaY = clientY - state.clientY
				var translateX = state.translateX
				var translateY = state.translateY
				var axis = state.axis
				var action = state.action
	
				// only check the axis once
				if (!axis) {
					axis = Math.abs(deltaY) >= Math.abs(deltaX) ? 'y' : 'x'
				}
	
				// only check the action once
				if (!action) {
					if (axis === 'y') {
						if (deltaY > 0) {
							action = 'pullDown'
						} else if (deltaY < 0) {
							action = 'pullUp'
						}
					} else if (axis === 'x') {
						if (deltaX > 0) {
							action = 'pullRight'
						} else if (deltaX < 0) {
							action = 'pullLeft'
						}
					}
				}
	
				if (options.detectBoundary) {
					var isBoundary = this.detectBoundary(action, deltaX, deltaY, translateX, translateY)
					if (isBoundary) return
				}
	
				var isActiveAction = this.isActiveAction(action)
	
				if (isActiveAction && options.detectScroll && !state[propMap[action]]) {
					extend(state, this.getScrollInfo())
					if (state[propMap[action]]) {
						deltaX = 0
						deltaY = 0
					}
				}
	
				var isActiveAndEnding = isActiveAction && state[propMap[action]]
	
				if (isActiveAndEnding) {
					translateX += transformValueByDamping(deltaX, options.damping)
					translateY += transformValueByDamping(deltaY, options.damping)
				}
	
				extend(state, {
					clientX: clientX,
					clientY: clientY,
					translateX: translateX,
					translateY: translateY,
					action: action,
					axis: axis
				})
	
				if (!isActiveAndEnding) {
					return
				}
	
				if (!options.drag) {
					if (axis === 'y') {
						translateX = 0
					} else if (axis === 'x') {
						translateY = 0
					}
				}
	
				this.emit(eventMap[action], {
					translateX: translateX,
					translateY: translateY
				})
	
				if (this.isPreventDefault) {
					this.isPreventDefault = false
					return
				}
	
				if (options.wait) {
					this.isWaiting = true
				}
	
				event.preventDefault()
				this.setTranslate(translateX, translateY)
			},
			handleTouchEnd: function() {
				if (!this.isTouching) {
					return
				}
				this.isTouching = false
	
				var state = this.state
				var action = state.action
				if (!this.isActiveAction(action) || !state[propMap[action]]) {
					return
				}
	
				this.emit(eventMap[action] + 'End', {
					translateX: state.translateX,
					translateY: state.translateY
				})
	
				if (this.isPreventDefault) {
					this.isPreventDefault = false
					return
				}
	
				this.animateToOrigin()
			}
		})
	
		return PullElement
	})


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Header;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _goBack = __webpack_require__(20);
	
	var _goBack2 = _interopRequireDefault(_goBack);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Header() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'navbar' },
	        _react2.default.createElement(
	            'div',
	            { className: 'navbar-inner navbar-on-center' },
	            _react2.default.createElement(
	                'div',
	                { className: 'left sliding' },
	                _react2.default.createElement(
	                    'a',
	                    { href: 'javascript:;', className: 'back link', onClick: _goBack2.default },
	                    _react2.default.createElement('i', { className: 'icon icon-back' }),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        'Back'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'center sliding' },
	                'Pull-Element'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'right' },
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', className: 'open-panel link icon-only' },
	                    _react2.default.createElement('i', { className: 'icon icon-bars' })
	                )
	            )
	        )
	    );
	}

/***/ },
/* 4 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
		var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
		return new Promise(function (resolve) {
			setTimeout(resolve, time);
		});
	};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(24);


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(8);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(23).enable();
	  window.Promise = __webpack_require__(22);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(26);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(21);


/***/ },
/* 8 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(1);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Home = __webpack_require__(12);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _PullToRefresh = __webpack_require__(14);
	
	var _PullToRefresh2 = _interopRequireDefault(_PullToRefresh);
	
	var _SwipeToShowAction = __webpack_require__(17);
	
	var _SwipeToShowAction2 = _interopRequireDefault(_SwipeToShowAction);
	
	var _AnimatedTabs = __webpack_require__(10);
	
	var _AnimatedTabs2 = _interopRequireDefault(_AnimatedTabs);
	
	var _SwipeableTabs = __webpack_require__(18);
	
	var _SwipeableTabs2 = _interopRequireDefault(_SwipeableTabs);
	
	var _SliderHorizontal = __webpack_require__(15);
	
	var _SliderHorizontal2 = _interopRequireDefault(_SliderHorizontal);
	
	var _VerticalSwiper = __webpack_require__(19);
	
	var _VerticalSwiper2 = _interopRequireDefault(_VerticalSwiper);
	
	var _SpaceBetweenSlides = __webpack_require__(16);
	
	var _SpaceBetweenSlides2 = _interopRequireDefault(_SpaceBetweenSlides);
	
	var _Playground = __webpack_require__(13);
	
	var _Playground2 = _interopRequireDefault(_Playground);
	
	var _CustomTrigger = __webpack_require__(11);
	
	var _CustomTrigger2 = _interopRequireDefault(_CustomTrigger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Array.from = Array.from || function (obj) {
	  return Array.prototype.slice.call(obj);
	};
	
	var components = {
	  '/': _Home2.default,
	  playground: _Playground2.default,
	  'pull-to-refresh': _PullToRefresh2.default,
	  'swipe-to-show-action': _SwipeToShowAction2.default,
	  'animated-tabs': _AnimatedTabs2.default,
	  'swipeable-tabs': _SwipeableTabs2.default,
	  'slider-horizontal': _SliderHorizontal2.default,
	  'vertical-swiper': _VerticalSwiper2.default,
	  'space-between-slides': _SpaceBetweenSlides2.default,
	  'custom-trigger': _CustomTrigger2.default
	};
	
	function renderView() {
	  var Target = components[location.hash.substr(1)] || _Home2.default;
	  _reactDom2.default.render(_react2.default.createElement(Target, null), document.getElementById('root'));
	}
	
	window.addEventListener('hashchange', renderView);
	renderView();

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ = __webpack_require__(2);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnimatedTabs = function (_Component) {
		_inherits(AnimatedTabs, _Component);
	
		function AnimatedTabs() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, AnimatedTabs);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AnimatedTabs.__proto__ || Object.getPrototypeOf(AnimatedTabs)).call.apply(_ref, [this].concat(args))), _this), _this.handleSwitchTab = function (_ref2) {
				var currentTarget = _ref2.currentTarget;
				var _this$refs = _this.refs,
				    tabs = _this$refs.tabs,
				    target = _this$refs.target;
	
				Array.from(tabs.querySelectorAll('.tab-link')).forEach(function (elem, index) {
					if (elem !== currentTarget) {
						elem.classList.remove('active');
					} else {
						elem.classList.add('active');
						_this.pullElement.animateTo(-target.clientWidth * index, 0);
					}
				});
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(AnimatedTabs, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _refs = this.refs,
				    target = _refs.target,
				    tabs = _refs.tabs;
	
				this.pullElement = new _2.default({
					target: target
				});
				this.pullElement.init();
				this.pullElement.disable();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.pullElement.destroy();
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'views' },
					_react2.default.createElement(
						'div',
						{ className: 'view view-main' },
						_react2.default.createElement(
							'div',
							{ className: 'navbar' },
							_react2.default.createElement(
								'div',
								{ className: 'navbar-inner' },
								_react2.default.createElement(
									'div',
									{ className: 'left sliding' },
									_react2.default.createElement(
										'a',
										{ href: '#/', className: 'back link' },
										_react2.default.createElement('i', { className: 'icon icon-back' }),
										_react2.default.createElement(
											'span',
											null,
											'Back'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'center sliding' },
									'Animated Tabs'
								),
								_react2.default.createElement(
									'div',
									{ className: 'right' },
									_react2.default.createElement(
										'a',
										{ href: '#/', className: 'link open-panel icon-only' },
										_react2.default.createElement('i', { className: 'icon icon-bars' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'subnavbar sliding' },
									_react2.default.createElement(
										'div',
										{ className: 'buttons-row', ref: 'tabs' },
										_react2.default.createElement(
											'a',
											{ href: 'javascript:;', className: 'button active tab-link', onClick: this.handleSwitchTab },
											'Tab 1'
										),
										_react2.default.createElement(
											'a',
											{ href: 'javascript:;', className: 'button tab-link', onClick: this.handleSwitchTab },
											'Tab 2'
										),
										_react2.default.createElement(
											'a',
											{ href: 'javascript:;', className: 'button tab-link', onClick: this.handleSwitchTab },
											'Tab 3'
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'pages navbar-through' },
							_react2.default.createElement(
								'div',
								{ 'data-page': 'tabs-animated', className: 'page with-subnavbar' },
								_react2.default.createElement(
									'div',
									{ className: 'tabs-animated-wrap' },
									_react2.default.createElement('style', { type: 'text/css', dangerouslySetInnerHTML: { __html: '\n\t\t\t\t        \t\t\t.tabs-animated-wrap>.tabs {\n\t\t\t\t        \t\t\t\t -webkit-transition-duration: 0ms;\n    \t\t\t\t\t\t\t\t\t transition-duration: 0ms;\n\t\t\t\t        \t\t\t}\n\t\t\t\t        \t\t' } }),
									_react2.default.createElement(
										'div',
										{ className: 'tabs', ref: 'target' },
										_react2.default.createElement(
											'div',
											{ id: 'tab1', className: 'page-content tab' },
											_react2.default.createElement(
												'div',
												{ className: 'content-block' },
												_react2.default.createElement(
													'p',
													null,
													'This is tab 1 content'
												),
												_react2.default.createElement(
													'p',
													null,
													'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque elementum mi quis felis scelerisque faucibus. Aliquam ut commodo justo. Mauris vitae pharetra arcu. Sed tincidunt dui et nibh auctor pretium. Nam accumsan fermentum sem. Suspendisse potenti. Nulla sed orci malesuada, pellentesque elit vitae, cursus lorem. Praesent et vehicula sapien, ut rhoncus quam. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vitae mi nec lorem aliquet venenatis quis nec nibh. Aenean sit amet leo ligula. Fusce in massa et nisl dictum ultricies et vitae dui. Sed sagittis quis diam sed lobortis. Donec in massa pharetra, tristique purus vitae, consequat mauris. Aliquam tellus ante, pharetra in mattis ut, dictum quis erat.'
												),
												_react2.default.createElement(
													'p',
													null,
													'Ut ac lobortis lacus, non pellentesque arcu. Quisque sodales sapien malesuada, condimentum nunc at, viverra lacus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Vivamus eu pulvinar turpis, id tristique quam. Aenean venenatis molestie diam, sit amet condimentum nisl pretium id. Donec diam tortor, mollis in vehicula id, vehicula consectetur nulla. Quisque posuere rutrum mauris, eu rutrum turpis blandit at. Proin volutpat tortor sit amet metus porttitor accumsan. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Ut dapibus posuere dictum.'
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ id: 'tab2', className: 'page-content tab' },
											_react2.default.createElement(
												'div',
												{ className: 'content-block' },
												_react2.default.createElement(
													'p',
													null,
													'This is tab 2 content'
												),
												_react2.default.createElement(
													'p',
													null,
													'Ut ac lobortis lacus, non pellentesque arcu. Quisque sodales sapien malesuada, condimentum nunc at, viverra lacus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Vivamus eu pulvinar turpis, id tristique quam. Aenean venenatis molestie diam, sit amet condimentum nisl pretium id. Donec diam tortor, mollis in vehicula id, vehicula consectetur nulla. Quisque posuere rutrum mauris, eu rutrum turpis blandit at. Proin volutpat tortor sit amet metus porttitor accumsan. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Ut dapibus posuere dictum.'
												),
												_react2.default.createElement(
													'p',
													null,
													'Fusce luctus turpis nunc, id porta orci blandit eget. Aenean sodales quam nec diam varius, in ornare ipsum condimentum. Aenean eleifend, nulla sit amet volutpat adipiscing, ligula nulla pharetra risus, vitae consequat leo tortor eu nunc. Vivamus at fringilla metus. Duis neque lectus, sagittis in volutpat a, pretium vel turpis. Nam accumsan auctor libero, quis sodales felis faucibus quis. Etiam vestibulum sed nisl vel aliquet. Aliquam pellentesque leo a lacus ultricies scelerisque. Vestibulum vestibulum fermentum tincidunt. Proin eleifend metus non quam pretium, eu vehicula ipsum egestas. Nam eget nibh enim. Etiam sem leo, pellentesque a elit vel, egestas rhoncus enim. Morbi ultricies adipiscing tortor, vitae condimentum lacus hendrerit nec. Phasellus laoreet leo quis purus elementum, ut fringilla justo eleifend. Nunc ultricies a sapien vitae auctor. Aliquam id erat elementum, laoreet est et, dapibus ligula.'
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ id: 'tab3', className: 'page-content tab' },
											_react2.default.createElement(
												'div',
												{ className: 'content-block' },
												_react2.default.createElement(
													'p',
													null,
													'This is tab 3 content'
												),
												_react2.default.createElement(
													'p',
													null,
													'Nulla gravida libero eget lobortis iaculis. In sed elit eu nibh adipiscing faucibus. Sed ac accumsan lacus. In ut diam quis turpis fringilla volutpat. In ultrices dignissim consequat. Cras pretium tortor et lorem condimentum posuere. Nulla facilisi. Suspendisse pretium egestas lacus ac laoreet. Mauris rhoncus quis ipsum quis tristique. Vivamus ultricies urna quis nunc egestas, in euismod turpis fringilla. Nam tellus massa, vehicula eu sapien non, dapibus tempor lorem. Fusce placerat orci arcu, eu dignissim enim porttitor vel. Nullam porttitor vel dolor sed feugiat. Suspendisse potenti. Maecenas ac mattis odio. Sed vel ultricies lacus, sed posuere libero.'
												),
												_react2.default.createElement(
													'p',
													null,
													'Nulla gravida libero eget lobortis iaculis. In sed elit eu nibh adipiscing faucibus. Sed ac accumsan lacus. In ut diam quis turpis fringilla volutpat. In ultrices dignissim consequat. Cras pretium tortor et lorem condimentum posuere. Nulla facilisi. Suspendisse pretium egestas lacus ac laoreet. Mauris rhoncus quis ipsum quis tristique. Vivamus ultricies urna quis nunc egestas, in euismod turpis fringilla. Nam tellus massa, vehicula eu sapien non, dapibus tempor lorem. Fusce placerat orci arcu, eu dignissim enim porttitor vel. Nullam porttitor vel dolor sed feugiat. Suspendisse potenti. Maecenas ac mattis odio. Sed vel ultricies lacus, sed posuere libero.'
												)
											)
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return AnimatedTabs;
	}(_react.Component);
	
	exports.default = AnimatedTabs;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(5);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = PullToRefresh;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(3);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _ = __webpack_require__(2);
	
	var _2 = _interopRequireDefault(_);
	
	var _delay = __webpack_require__(4);
	
	var _delay2 = _interopRequireDefault(_delay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function PullToRefresh() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'views' },
	    _react2.default.createElement(
	      'div',
	      { className: 'view view-main' },
	      _react2.default.createElement(_Header2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: 'pages navbar-through toolbar-through' },
	        _react2.default.createElement(
	          'div',
	          { className: 'page page-on-center' },
	          _react2.default.createElement(Content, null)
	        )
	      )
	    )
	  );
	}
	
	var Content = function (_Component) {
	  _inherits(Content, _Component);
	
	  function Content(props) {
	    _classCallCheck(this, Content);
	
	    var _this = _possibleConstructorReturn(this, (Content.__proto__ || Object.getPrototypeOf(Content)).call(this, props));
	
	    _this.state = {
	      data: [_this.fetchData(), _this.fetchData(), _this.fetchData()]
	    };
	    return _this;
	  }
	
	  _createClass(Content, [{
	    key: 'fetchData',
	    value: function fetchData() {
	      var songs = ['Yellow Submarine', "Don't Stop Me Now", 'Billie Jean', 'Californication'];
	      var authors = ['Beatles', 'Queen', 'Michael Jackson', 'Red Hot Chili Peppers'];
	      var picURL = 'http://lorempixel.com/88/88/abstract/' + Math.round(Math.random() * 10);
	      var song = songs[Math.floor(Math.random() * songs.length)];
	      var author = authors[Math.floor(Math.random() * authors.length)];
	      return { picURL: picURL, song: song, author: author };
	    }
	  }, {
	    key: 'fetchDataAsync',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return (0, _delay2.default)(time);
	
	              case 2:
	                return _context.abrupt('return', this.fetchData());
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function fetchDataAsync() {
	        return _ref.apply(this, arguments);
	      }
	
	      return fetchDataAsync;
	    }()
	  }, {
	    key: 'refresh',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var newItem;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return this.fetchDataAsync();
	
	              case 2:
	                newItem = _context2.sent;
	
	                this.setState({
	                  data: [newItem].concat(this.state.data)
	                });
	
	              case 4:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function refresh() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return refresh;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var component = this;
	      var _refs = this.refs,
	          target = _refs.target,
	          content = _refs.content;
	
	      var pullElement = new _2.default({
	        target: target,
	        trigger: '#trigger',
	        scroller: content,
	        detectScroll: true,
	        detectBoundary: true,
	        onPullDown: function onPullDown(_ref3) {
	          var translateY = _ref3.translateY;
	
	          var classList = content.classList;
	          if (translateY > 45) {
	            classList.remove('pull-down');
	            classList.add('pull-up');
	          } else {
	            classList.add('pull-down');
	            classList.remove('pull-up');
	          }
	        },
	        onPullDownEnd: function () {
	          var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(_ref4) {
	            var translateY = _ref4.translateY;
	            var classList;
	            return _regenerator2.default.wrap(function _callee3$(_context3) {
	              while (1) {
	                switch (_context3.prev = _context3.next) {
	                  case 0:
	                    classList = content.classList;
	
	                    classList.remove('pull-down');
	                    classList.remove('pull-up');
	
	                    if (!(translateY > 45)) {
	                      _context3.next = 11;
	                      break;
	                    }
	
	                    this.preventDefault();
	                    classList.add('refreshing');
	                    this.animateTo(0, 0);
	                    _context3.next = 9;
	                    return component.refresh();
	
	                  case 9:
	                    classList.remove('refreshing');
	                    this.animateToOrigin();
	
	                  case 11:
	                  case 'end':
	                    return _context3.stop();
	                }
	              }
	            }, _callee3, this);
	          }));
	
	          function onPullDownEnd(_x2) {
	            return _ref5.apply(this, arguments);
	          }
	
	          return onPullDownEnd;
	        }()
	      });
	      pullElement.init();
	      this.pullElement = pullElement;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.pullElement.destroy();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: 'target',
	          style: { width: '100%', height: '100%', position: 'relative' }
	        },
	        _react2.default.createElement(
	          'i',
	          {
	            className: 'icon icon-red',
	            id: 'trigger',
	            style: {
	              position: 'fixed',
	              top: '50%',
	              right: 50,
	              zIndex: 100,
	              width: 50,
	              height: 50,
	              lineHeight: '50px'
	            }
	          },
	          'Trigger'
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'page-content pull-to-refresh-content transitioning',
	            ref: 'content'
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'pull-to-refresh-layer' },
	            _react2.default.createElement('div', { className: 'preloader' }),
	            _react2.default.createElement('div', { className: 'pull-to-refresh-arrow' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'list-block media-list' },
	            _react2.default.createElement(
	              'ul',
	              null,
	              this.state.data.map(function (item) {
	                return _react2.default.createElement(
	                  'li',
	                  {
	                    className: 'item-content',
	                    key: item.picURL + item.song + item.author
	                  },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'item-media' },
	                    _react2.default.createElement('img', { src: item.picURL, width: '44' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'item-inner' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'item-title-row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'item-title' },
	                        item.song
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'item-subtitle' },
	                      item.author
	                    )
	                  )
	                );
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'list-block-label' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'Just pull page down to let the magic happen.',
	                _react2.default.createElement('br', null),
	                'Note that pull-to-refresh feature is optimised for touch and native scrolling so it may not work on desktop browser.'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Content;
	}(_react.Component);

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Menu;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(3);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Menu(_ref) {
		var hash = _ref.hash;
	
		return _react2.default.createElement(
			'div',
			{ className: 'views' },
			_react2.default.createElement(
				'div',
				{ className: 'view view-main', 'data-page': 'index' },
				_react2.default.createElement(_Header2.default, null),
				_react2.default.createElement(
					'div',
					{ className: 'pages navbar-through toolbar-through' },
					_react2.default.createElement(
						'div',
						{ 'data-page': 'index', className: 'page page-on-center' },
						_react2.default.createElement(
							'div',
							{ className: 'page-content' },
							_react2.default.createElement(
								'div',
								{ className: 'content-block-title' },
								'Welcome To Pull-Element'
							),
							_react2.default.createElement(
								'div',
								{ className: 'content-block' },
								_react2.default.createElement(
									'a',
									{ href: 'https://github.com/Lucifier129/pull-element', className: 'button' },
									'About Pull-Element'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'content-block-title' },
								'Pull-Element Kitchen Sink'
							),
							_react2.default.createElement(
								'div',
								{ className: 'list-block' },
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(ListItem, { href: '#pull-to-refresh', text: 'Pull To Refresh', iconText: 'P' }),
									_react2.default.createElement(ListItem, { href: '#swipe-to-show-action', text: 'Swipe To Show Action', iconText: 'S' }),
									_react2.default.createElement(ListItem, { href: '#animated-tabs', text: 'Animated Tabs', iconText: 'A' }),
									_react2.default.createElement(ListItem, { href: '#swipeable-tabs', text: 'Swipeable Tabs', iconText: 'S' }),
									_react2.default.createElement(ListItem, { href: '#slider-horizontal', text: 'Slider Horizontal', iconText: 'S' }),
									_react2.default.createElement(ListItem, { href: '#vertical-swiper', text: 'Vertical Swiper', iconText: 'V' }),
									_react2.default.createElement(ListItem, { href: '#space-between-slides', text: 'Space Between Slides', iconText: 'S' }),
									_react2.default.createElement(ListItem, { href: '#custom-trigger', text: 'CustomTrigger', iconText: 'C' }),
									_react2.default.createElement(ListItem, { href: '#playground', text: 'Playground', iconText: 'P' })
								)
							)
						)
					)
				)
			)
		);
	}
	
	function ListItem(_ref2) {
		var _ref2$href = _ref2.href,
		    href = _ref2$href === undefined ? 'javascript:;' : _ref2$href,
		    _ref2$text = _ref2.text,
		    text = _ref2$text === undefined ? '' : _ref2$text,
		    _ref2$iconText = _ref2.iconText,
		    iconText = _ref2$iconText === undefined ? '' : _ref2$iconText;
	
		return _react2.default.createElement(
			'li',
			null,
			_react2.default.createElement(
				'a',
				{ href: href, className: 'item-link' },
				_react2.default.createElement(
					'div',
					{ className: 'item-content' },
					_react2.default.createElement(
						'div',
						{ className: 'item-media' },
						_react2.default.createElement(
							'i',
							{ className: 'icon icon-red' },
							iconText
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'item-inner' },
						_react2.default.createElement(
							'div',
							{ className: 'item-title' },
							text
						)
					)
				)
			)
		);
	}

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = Playground;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(3);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _ = __webpack_require__(2);
	
	var _2 = _interopRequireDefault(_);
	
	var _delay = __webpack_require__(4);
	
	var _delay2 = _interopRequireDefault(_delay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function Playground() {
		return _react2.default.createElement(
			'div',
			{ className: 'views' },
			_react2.default.createElement(
				'div',
				{ className: 'view view-main' },
				_react2.default.createElement(_Header2.default, null),
				_react2.default.createElement(
					'div',
					{ className: 'pages navbar-through toolbar-through' },
					_react2.default.createElement(
						'div',
						{ className: 'page page-on-center' },
						_react2.default.createElement(Content, null)
					)
				)
			)
		);
	}
	
	var Content = function (_Component) {
		_inherits(Content, _Component);
	
		function Content() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, Content);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Content.__proto__ || Object.getPrototypeOf(Content)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
				damping: 1.6,
				pullUp: false,
				pullDown: true,
				pullLeft: false,
				pullRight: false,
				detectScroll: true,
				detectScrollOnStart: false,
				detectScrollOnMove: false,
				detectBoundary: true,
				drag: false,
				transitionDuration: '0.3s',
				transitionTimingFunction: 'ease-out'
			}, _this.handleChange = function (_ref2) {
				var currentTarget = _ref2.currentTarget;
				var name = currentTarget.name,
				    value = currentTarget.value,
				    checked = currentTarget.checked,
				    type = currentTarget.type;
	
				_this.setState(_defineProperty({}, name, type === 'checkbox' ? checked : value));
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(Content, [{
			key: 'addPullElement',
			value: function addPullElement() {
				if (this.pullElement) {
					this.pullElement.destroy();
				}
				var _refs = this.refs,
				    target = _refs.target,
				    content = _refs.content;
	
				var options = Object.assign({}, this.state, {
					damping: Number(this.state.damping)
				});
				var pullElement = new _2.default(Object.assign({
					target: target
				}, options));
				pullElement.init();
				this.pullElement = pullElement;
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.addPullElement();
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				this.addPullElement();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.pullElement.destroy();
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ ref: 'target', className: 'list-block', style: { height: '100%', padding: '0 10px', overflow: 'auto' } },
					_react2.default.createElement(
						'div',
						{ className: 'page-content', ref: 'content', style: { height: '120%' } },
						_react2.default.createElement(
							'div',
							{ className: 'content-block-title' },
							'Pull Element options'
						),
						_react2.default.createElement(
							'form',
							{ className: 'list-block' },
							_react2.default.createElement(
								'ul',
								null,
								_react2.default.createElement(TextInput, {
									label: 'transition-duration',
									name: 'transitionDuration',
									value: this.state.transitionDuration,
									onChange: this.handleChange
								}),
								_react2.default.createElement(SelectInput, {
									label: 'transition-timing-function',
									name: 'transitionTimingFunction',
									value: this.state.transitionTimingFunction,
									onChange: this.handleChange,
									options: ['ease-in', 'ease-out', 'ease-in-out', 'linear', 'ease']
								}),
								_react2.default.createElement(TextInput, {
									label: 'damping',
									name: 'damping',
									value: this.state.damping,
									onChange: this.handleChange
								}),
								_react2.default.createElement(Checkbox, {
									label: 'pullUp',
									name: 'pullUp',
									checked: this.state.pullUp,
									onChange: this.handleChange
								}),
								_react2.default.createElement(Checkbox, {
									label: 'pullDown',
									name: 'pullDown',
									checked: this.state.pullDown,
									onChange: this.handleChange
								}),
								_react2.default.createElement(Checkbox, {
									label: 'pullLeft',
									name: 'pullLeft',
									checked: this.state.pullLeft,
									onChange: this.handleChange
								}),
								_react2.default.createElement(Checkbox, {
									label: 'pullRight',
									name: 'pullRight',
									checked: this.state.pullRight,
									onChange: this.handleChange
								}),
								_react2.default.createElement(Checkbox, {
									label: 'detectScroll',
									name: 'detectScroll',
									checked: this.state.detectScroll,
									onChange: this.handleChange
								}),
								_react2.default.createElement(Checkbox, {
									label: 'detectScrollOnStart',
									name: 'detectScrollOnStart',
									checked: this.state.detectScrollOnStart,
									onChange: this.handleChange
								}),
								_react2.default.createElement(Checkbox, {
									label: 'drag',
									name: 'drag',
									checked: this.state.drag,
									onChange: this.handleChange
								})
							)
						)
					)
				);
			}
		}]);
	
		return Content;
	}(_react.Component);
	
	function TextInput(_ref3) {
		var label = _ref3.label,
		    _ref3$type = _ref3.type,
		    type = _ref3$type === undefined ? "text" : _ref3$type,
		    name = _ref3.name,
		    value = _ref3.value,
		    placeholder = _ref3.placeholder,
		    onChange = _ref3.onChange;
	
		return _react2.default.createElement(
			'li',
			null,
			_react2.default.createElement(
				'div',
				{ className: 'item-content' },
				_react2.default.createElement(
					'div',
					{ className: 'item-inner' },
					_react2.default.createElement(
						'div',
						{ className: 'item-title label', style: { width: '50%' } },
						label
					),
					_react2.default.createElement(
						'div',
						{ className: 'item-input' },
						_react2.default.createElement('input', {
							type: 'text',
							name: name,
							placeholder: placeholder,
							value: value,
							onChange: onChange
						})
					)
				)
			)
		);
	}
	
	function SelectInput(_ref4) {
		var label = _ref4.label,
		    name = _ref4.name,
		    value = _ref4.value,
		    onChange = _ref4.onChange,
		    options = _ref4.options;
	
		return _react2.default.createElement(
			'li',
			null,
			_react2.default.createElement(
				'div',
				{ className: 'item-content' },
				_react2.default.createElement(
					'div',
					{ className: 'item-inner' },
					_react2.default.createElement(
						'div',
						{ className: 'item-title label', style: { width: '50%' } },
						label
					),
					_react2.default.createElement(
						'div',
						{ className: 'item-input' },
						_react2.default.createElement(
							'select',
							{ name: name, value: value, onChange: onChange },
							options.map(function (option) {
								return _react2.default.createElement(
									'option',
									{ value: option },
									option
								);
							})
						)
					)
				)
			)
		);
	}
	
	function Checkbox(_ref5) {
		var label = _ref5.label,
		    checked = _ref5.checked,
		    name = _ref5.name,
		    value = _ref5.value,
		    onChange = _ref5.onChange;
	
		return _react2.default.createElement(
			'li',
			null,
			_react2.default.createElement(
				'div',
				{ className: 'item-content' },
				_react2.default.createElement(
					'div',
					{ className: 'item-inner' },
					_react2.default.createElement(
						'div',
						{ className: 'item-title label', style: { width: '50%' } },
						label
					),
					_react2.default.createElement(
						'div',
						{ className: 'item-input' },
						_react2.default.createElement(
							'label',
							{ className: 'label-switch' },
							_react2.default.createElement('input', { type: 'checkbox', name: name, checked: checked, onChange: onChange }),
							_react2.default.createElement('div', { className: 'checkbox' })
						)
					)
				)
			)
		);
	}

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(5);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = PullToRefresh;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(3);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _ = __webpack_require__(2);
	
	var _2 = _interopRequireDefault(_);
	
	var _delay = __webpack_require__(4);
	
	var _delay2 = _interopRequireDefault(_delay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function PullToRefresh() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'views' },
	    _react2.default.createElement(
	      'div',
	      { className: 'view view-main' },
	      _react2.default.createElement(_Header2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: 'pages navbar-through toolbar-through' },
	        _react2.default.createElement(
	          'div',
	          { className: 'page page-on-center' },
	          _react2.default.createElement(Content, null)
	        )
	      )
	    )
	  );
	}
	
	var Content = function (_Component) {
	  _inherits(Content, _Component);
	
	  function Content(props) {
	    _classCallCheck(this, Content);
	
	    var _this = _possibleConstructorReturn(this, (Content.__proto__ || Object.getPrototypeOf(Content)).call(this, props));
	
	    _this.state = {
	      data: [_this.fetchData(), _this.fetchData(), _this.fetchData()]
	    };
	    return _this;
	  }
	
	  _createClass(Content, [{
	    key: 'fetchData',
	    value: function fetchData() {
	      var songs = ['Yellow Submarine', "Don't Stop Me Now", 'Billie Jean', 'Californication'];
	      var authors = ['Beatles', 'Queen', 'Michael Jackson', 'Red Hot Chili Peppers'];
	      var picURL = 'http://lorempixel.com/88/88/abstract/' + Math.round(Math.random() * 10);
	      var song = songs[Math.floor(Math.random() * songs.length)];
	      var author = authors[Math.floor(Math.random() * authors.length)];
	      return { picURL: picURL, song: song, author: author };
	    }
	  }, {
	    key: 'fetchDataAsync',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return (0, _delay2.default)(time);
	
	              case 2:
	                return _context.abrupt('return', this.fetchData());
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function fetchDataAsync() {
	        return _ref.apply(this, arguments);
	      }
	
	      return fetchDataAsync;
	    }()
	  }, {
	    key: 'refresh',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var newItem;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return this.fetchDataAsync();
	
	              case 2:
	                newItem = _context2.sent;
	
	                this.setState({
	                  data: [newItem].concat(this.state.data)
	                });
	
	              case 4:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function refresh() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return refresh;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var component = this;
	      var _refs = this.refs,
	          target = _refs.target,
	          content = _refs.content;
	
	      var pullElement = new _2.default({
	        target: target,
	        scroller: content,
	        detectScroll: true,
	        detectBoundary: true,
	        onPullDown: function onPullDown(_ref3) {
	          var translateY = _ref3.translateY;
	
	          var classList = content.classList;
	          if (translateY > 45) {
	            classList.remove('pull-down');
	            classList.add('pull-up');
	          } else {
	            classList.add('pull-down');
	            classList.remove('pull-up');
	          }
	        },
	        onPullDownEnd: function () {
	          var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(_ref4) {
	            var translateY = _ref4.translateY;
	            var classList;
	            return _regenerator2.default.wrap(function _callee3$(_context3) {
	              while (1) {
	                switch (_context3.prev = _context3.next) {
	                  case 0:
	                    classList = content.classList;
	
	                    classList.remove('pull-down');
	                    classList.remove('pull-up');
	
	                    if (!(translateY > 45)) {
	                      _context3.next = 11;
	                      break;
	                    }
	
	                    this.preventDefault();
	                    classList.add('refreshing');
	                    this.animateTo(0, 0);
	                    _context3.next = 9;
	                    return component.refresh();
	
	                  case 9:
	                    classList.remove('refreshing');
	                    this.animateToOrigin();
	
	                  case 11:
	                  case 'end':
	                    return _context3.stop();
	                }
	              }
	            }, _callee3, this);
	          }));
	
	          function onPullDownEnd(_x2) {
	            return _ref5.apply(this, arguments);
	          }
	
	          return onPullDownEnd;
	        }()
	      });
	      pullElement.init();
	      this.pullElement = pullElement;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.pullElement.destroy();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { ref: 'target', style: { width: '100%', height: '100%' } },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'page-content pull-to-refresh-content transitioning',
	            ref: 'content'
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'pull-to-refresh-layer' },
	            _react2.default.createElement('div', { className: 'preloader' }),
	            _react2.default.createElement('div', { className: 'pull-to-refresh-arrow' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'list-block media-list' },
	            _react2.default.createElement(
	              'ul',
	              null,
	              this.state.data.map(function (item) {
	                return _react2.default.createElement(
	                  'li',
	                  {
	                    className: 'item-content',
	                    key: item.picURL + item.song + item.author
	                  },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'item-media' },
	                    _react2.default.createElement('img', { src: item.picURL, width: '44' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'item-inner' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'item-title-row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'item-title' },
	                        item.song
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'item-subtitle' },
	                      item.author
	                    )
	                  )
	                );
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'list-block-label' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'Just pull page down to let the magic happen.',
	                _react2.default.createElement('br', null),
	                'Note that pull-to-refresh feature is optimised for touch and native scrolling so it may not work on desktop browser.'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Content;
	}(_react.Component);

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ = __webpack_require__(2);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SliderHorizontal = function (_Component) {
		_inherits(SliderHorizontal, _Component);
	
		function SliderHorizontal() {
			_classCallCheck(this, SliderHorizontal);
	
			return _possibleConstructorReturn(this, (SliderHorizontal.__proto__ || Object.getPrototypeOf(SliderHorizontal)).apply(this, arguments));
		}
	
		_createClass(SliderHorizontal, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var component = this;
				var target = this.refs.target;
	
				var clientWidth = target.clientWidth;
				var activeIndex = 0;
				var handlePullEnd = function handlePullEnd(_ref) {
					var translateX = _ref.translateX;
	
					this.preventDefault();
					var prevTranslateX = -clientWidth * activeIndex;
					var diff = translateX - prevTranslateX;
					if (diff > 50) {
						activeIndex -= 1;
					} else if (diff < -50) {
						activeIndex += 1;
					}
					if (activeIndex < 0) {
						activeIndex = 0;
					} else if (activeIndex > 9) {
						activeIndex = 9;
					}
					component.switchSlide(activeIndex);
				};
				this.pullElement = new _2.default({
					target: target,
					wait: false,
					onPullLeftEnd: handlePullEnd,
					onPullRightEnd: handlePullEnd
				});
				this.pullElement.init();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.pullElement.destroy();
			}
		}, {
			key: 'switchSlide',
			value: function switchSlide(index) {
				this.animateTo(index);
				this.switchAtiveStatus(index);
			}
		}, {
			key: 'animateTo',
			value: function animateTo(index) {
				var target = this.refs.target;
	
				var translateX = -target.clientWidth * index;
				this.pullElement.animateTo(translateX, 0);
			}
		}, {
			key: 'switchAtiveStatus',
			value: function switchAtiveStatus(activeIndex) {
				var tabItems = Array.from(this.refs.paginations.querySelectorAll('.swiper-pagination-bullet'));
				tabItems.forEach(function (elem, index) {
					if (activeIndex === index) {
						elem.classList.add('swiper-pagination-bullet-active');
					} else {
						elem.classList.remove('swiper-pagination-bullet-active');
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'views' },
					_react2.default.createElement(
						'div',
						{ className: 'view view-main' },
						_react2.default.createElement(
							'div',
							{ className: 'navbar' },
							_react2.default.createElement(
								'div',
								{ className: 'navbar-inner' },
								_react2.default.createElement(
									'div',
									{ className: 'left sliding' },
									_react2.default.createElement(
										'a',
										{ href: '#/', className: 'back link' },
										_react2.default.createElement('i', { className: 'icon icon-back' }),
										_react2.default.createElement(
											'span',
											null,
											'Back'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'center sliding' },
									'Slider Horizontal'
								),
								_react2.default.createElement(
									'div',
									{ className: 'right' },
									_react2.default.createElement(
										'a',
										{ href: '#/', className: 'open-panel link icon-only' },
										_react2.default.createElement('i', { className: 'icon icon-bars' })
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'pages navbar-through' },
							_react2.default.createElement(
								'div',
								{ 'data-page': 'swiper-horizontal', className: 'page page-on-center' },
								_react2.default.createElement(
									'div',
									{ className: 'page-content' },
									_react2.default.createElement(
										'div',
										{ className: 'swiper-container swiper-init ks-demo-slider swiper-container-horizontal' },
										_react2.default.createElement(
											'div',
											{ className: 'swiper-pagination swiper-pagination-bullets', ref: 'paginations' },
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet swiper-pagination-bullet-active' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'swiper-wrapper', ref: 'target' },
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide' },
												'Slide 1'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide' },
												'Slide 2'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide' },
												'Slide 3'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide' },
												'Slide 4'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide' },
												'Slide 5'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide' },
												'Slide 6'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide' },
												'Slide 7'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide' },
												'Slide 8'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide' },
												'Slide 9'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide' },
												'Slide 10'
											)
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return SliderHorizontal;
	}(_react.Component);
	
	exports.default = SliderHorizontal;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ = __webpack_require__(2);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SpaceBetweenSlides = function (_Component) {
		_inherits(SpaceBetweenSlides, _Component);
	
		function SpaceBetweenSlides() {
			_classCallCheck(this, SpaceBetweenSlides);
	
			return _possibleConstructorReturn(this, (SpaceBetweenSlides.__proto__ || Object.getPrototypeOf(SpaceBetweenSlides)).apply(this, arguments));
		}
	
		_createClass(SpaceBetweenSlides, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var component = this;
				var target = this.refs.target;
	
				var clientWidth = target.clientWidth;
				var activeIndex = 0;
				var handlePullEnd = function handlePullEnd(_ref) {
					var translateX = _ref.translateX;
	
					this.preventDefault();
					var prevTranslateX = -activeIndex * (clientWidth + 50);
					var diff = translateX - prevTranslateX;
					if (diff > 50) {
						activeIndex -= 1;
					} else if (diff < -50) {
						activeIndex += 1;
					}
					if (activeIndex < 0) {
						activeIndex = 0;
					} else if (activeIndex > 9) {
						activeIndex = 9;
					}
					component.switchSlide(activeIndex);
				};
				this.pullElement = new _2.default({
					target: target,
					isStatic: true,
					wait: false,
					onPullLeftEnd: handlePullEnd,
					onPullRightEnd: handlePullEnd
				});
				this.pullElement.init();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.pullElement.destroy();
			}
		}, {
			key: 'switchSlide',
			value: function switchSlide(index) {
				this.animateTo(index);
				this.switchAtiveStatus(index);
			}
		}, {
			key: 'animateTo',
			value: function animateTo(index) {
				var target = this.refs.target;
	
				var translateX = -(target.clientWidth + 50) * index;
				this.pullElement.animateTo(translateX, 0);
			}
		}, {
			key: 'switchAtiveStatus',
			value: function switchAtiveStatus(activeIndex) {
				var tabItems = Array.from(this.refs.paginations.querySelectorAll('.swiper-pagination-bullet'));
				tabItems.forEach(function (elem, index) {
					if (activeIndex === index) {
						elem.classList.add('swiper-pagination-bullet-active');
					} else {
						elem.classList.remove('swiper-pagination-bullet-active');
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'views' },
					_react2.default.createElement(
						'div',
						{ className: 'view view-main' },
						_react2.default.createElement(
							'div',
							{ className: 'navbar' },
							_react2.default.createElement(
								'div',
								{ className: 'navbar-inner' },
								_react2.default.createElement(
									'div',
									{ className: 'left sliding' },
									_react2.default.createElement(
										'a',
										{ href: '#/', className: 'back link' },
										_react2.default.createElement('i', { className: 'icon icon-back' }),
										_react2.default.createElement(
											'span',
											null,
											'Back'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'center sliding' },
									'Space Between Slides'
								),
								_react2.default.createElement(
									'div',
									{ className: 'right' },
									_react2.default.createElement(
										'a',
										{ href: '#/', className: 'open-panel link icon-only' },
										_react2.default.createElement('i', { className: 'icon icon-bars' })
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'pages navbar-through' },
							_react2.default.createElement(
								'div',
								{ 'data-page': 'swiper-horizontal', className: 'page page-on-center' },
								_react2.default.createElement(
									'div',
									{ className: 'page-content' },
									_react2.default.createElement(
										'div',
										{ className: 'swiper-container swiper-init ks-demo-slider swiper-container-horizontal' },
										_react2.default.createElement(
											'div',
											{ className: 'swiper-pagination swiper-pagination-bullets', ref: 'paginations' },
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet swiper-pagination-bullet-active' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'swiper-wrapper', ref: 'target' },
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide', style: { marginRight: 50 } },
												'Slide 1'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide', style: { marginRight: 50 } },
												'Slide 2'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide', style: { marginRight: 50 } },
												'Slide 3'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide', style: { marginRight: 50 } },
												'Slide 4'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide', style: { marginRight: 50 } },
												'Slide 5'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide', style: { marginRight: 50 } },
												'Slide 6'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide', style: { marginRight: 50 } },
												'Slide 7'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide', style: { marginRight: 50 } },
												'Slide 8'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide', style: { marginRight: 50 } },
												'Slide 9'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide', style: { marginRight: 50 } },
												'Slide 10'
											)
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return SpaceBetweenSlides;
	}(_react.Component);
	
	exports.default = SpaceBetweenSlides;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = Root;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(3);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _ = __webpack_require__(2);
	
	var _2 = _interopRequireDefault(_);
	
	var _delay = __webpack_require__(4);
	
	var _delay2 = _interopRequireDefault(_delay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function Root() {
		return _react2.default.createElement(
			'div',
			{ className: 'views' },
			_react2.default.createElement(
				'div',
				{ className: 'view view-main', 'data-page': 'index' },
				_react2.default.createElement(_Header2.default, null),
				_react2.default.createElement(
					'div',
					{ className: 'pages navbar-through toolbar-through' },
					_react2.default.createElement(
						'div',
						{ className: 'page page-on-center' },
						_react2.default.createElement(
							'div',
							{ className: 'page-content' },
							_react2.default.createElement(
								'div',
								{ className: 'content-block' },
								_react2.default.createElement(
									'p',
									null,
									'Swipe out actions on list elements. It allows you to call hidden menu for each list element where you can put default ready-to use delete button or any other buttons for some required actions. '
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'content-block-title' },
								'Swipe to show hidden action'
							),
							_react2.default.createElement(
								'div',
								{ className: 'list-block' },
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(SwipeToShowAction, { text: 'Swipe left on me please' }),
									_react2.default.createElement(SwipeToShowTowActions, { text: 'Swipe left on me for more actions' }),
									_react2.default.createElement(SwipeToShowActionOnRight, { text: 'Swipe right on me please' }),
									_react2.default.createElement(
										'li',
										{ className: 'swipeout' },
										_react2.default.createElement(
											'div',
											null,
											_react2.default.createElement(
												'div',
												{ className: 'item-content swipeout-content' },
												_react2.default.createElement(
													'div',
													{ className: 'item-media' },
													_react2.default.createElement(
														'i',
														{ className: 'icon icon-red' },
														'S'
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'item-inner', style: { minHeight: 50 } },
													_react2.default.createElement(
														'div',
														{ className: 'item-title' },
														'I can\'t swipe to show action'
													)
												)
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'content-block-title' },
								'On both sides with overswipes'
							),
							_react2.default.createElement(
								'div',
								{ className: 'list-block media-list' },
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(SwipeToShowActionOnBothSide, null)
								)
							)
						)
					)
				)
			)
		);
	}
	
	var SwipeToShowAction = function (_Component) {
		_inherits(SwipeToShowAction, _Component);
	
		function SwipeToShowAction() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, SwipeToShowAction);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SwipeToShowAction.__proto__ || Object.getPrototypeOf(SwipeToShowAction)).call.apply(_ref, [this].concat(args))), _this), _this.handleAction = function (_ref2) {
				var currentTarget = _ref2.currentTarget;
	
				alert(currentTarget.textContent);
				_this.pullElement.animateToOrigin();
			}, _this.handleOuterTouchStart = function (_ref3) {
				var target = _ref3.target;
	
				var node = _this.refs.node;
				if (node !== target && !node.contains(target)) {
					_this.pullElement.animateToOrigin();
				}
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(SwipeToShowAction, [{
			key: 'addPullElement',
			value: function addPullElement() {
				this.pullElement = new _2.default({
					target: this.refs.container,
					wait: false,
					onPullRight: function onPullRight(_ref4) {
						var translateX = _ref4.translateX;
	
						if (translateX >= 0) {
							this.preventDefault();
							this.setTranslate(0, 0);
						}
					},
					onPullLeft: function onPullLeft(_ref5) {
						var translateX = _ref5.translateX;
	
						if (-translateX > 109) {
							this.preventDefault();
							this.setTranslate(-109, 0);
						}
					},
					onPullLeftEnd: function onPullLeftEnd(_ref6) {
						var translateX = _ref6.translateX;
	
						if (-translateX >= 30) {
							this.preventDefault();
							this.animateTo(-109, 0);
						}
					}
				});
				this.pullElement.init();
			}
		}, {
			key: 'removePullElement',
			value: function removePullElement() {
				this.pullElement.destroy();
			}
		}, {
			key: 'addOuterTouchStartListener',
			value: function addOuterTouchStartListener() {
				document.addEventListener('touchstart', this.handleOuterTouchStart);
			}
		}, {
			key: 'removeOuterTouchStartListener',
			value: function removeOuterTouchStartListener() {
				document.removeEventListener('touchstart', this.handleOuterTouchStart);
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.addPullElement();
				this.addOuterTouchStartListener();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.removePullElement();
				this.removeOuterTouchStartListener();
			}
		}, {
			key: 'render',
			value: function render() {
				var text = this.props.text;
	
				return _react2.default.createElement(
					'li',
					{ className: 'swipeout', ref: 'node' },
					_react2.default.createElement(
						'div',
						{ ref: 'container' },
						_react2.default.createElement(
							'div',
							{ className: 'item-content swipeout-content' },
							_react2.default.createElement(
								'div',
								{ className: 'item-media' },
								_react2.default.createElement(
									'i',
									{ className: 'icon icon-red' },
									'S'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'item-inner', style: { minHeight: 50 } },
								_react2.default.createElement(
									'div',
									{ className: 'item-title' },
									text
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'swipeout-actions-right' },
							_react2.default.createElement(
								'a',
								{
									href: 'javascript:;',
									className: 'swipeout-delete',
									onClick: this.handleAction
								},
								'Delete'
							)
						)
					)
				);
			}
		}]);
	
		return SwipeToShowAction;
	}(_react.Component);
	
	var SwipeToShowTowActions = function (_Component2) {
		_inherits(SwipeToShowTowActions, _Component2);
	
		function SwipeToShowTowActions() {
			var _ref7;
	
			var _temp2, _this2, _ret2;
	
			_classCallCheck(this, SwipeToShowTowActions);
	
			for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				args[_key2] = arguments[_key2];
			}
	
			return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref7 = SwipeToShowTowActions.__proto__ || Object.getPrototypeOf(SwipeToShowTowActions)).call.apply(_ref7, [this].concat(args))), _this2), _this2.handleAction = function (_ref8) {
				var currentTarget = _ref8.currentTarget;
	
				alert(currentTarget.textContent);
				_this2.pullElement.animateToOrigin();
			}, _this2.handleOuterTouchStart = function (_ref9) {
				var target = _ref9.target;
	
				var node = _this2.refs.node;
				if (node !== target && !node.contains(target)) {
					_this2.pullElement.animateToOrigin();
				}
			}, _temp2), _possibleConstructorReturn(_this2, _ret2);
		}
	
		_createClass(SwipeToShowTowActions, [{
			key: 'addPullElement',
			value: function addPullElement() {
				this.pullElement = new _2.default({
					target: this.refs.container,
					wait: false,
					pullRight: true,
					onPullLeftEnd: function onPullLeftEnd(_ref10) {
						var translateX = _ref10.translateX;
	
						if (-translateX >= 50) {
							this.preventDefault();
							this.animateTo(-207, 0);
						}
					}
				});
				this.pullElement.init();
			}
		}, {
			key: 'removePullElement',
			value: function removePullElement() {
				this.pullElement.destroy();
			}
		}, {
			key: 'addOuterTouchStartListener',
			value: function addOuterTouchStartListener() {
				document.addEventListener('touchstart', this.handleOuterTouchStart);
			}
		}, {
			key: 'removeOuterTouchStartListener',
			value: function removeOuterTouchStartListener() {
				document.removeEventListener('touchstart', this.handleOuterTouchStart);
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.addPullElement();
				this.addOuterTouchStartListener();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.removePullElement();
				this.removeOuterTouchStartListener();
			}
		}, {
			key: 'render',
			value: function render() {
				var text = this.props.text;
	
				return _react2.default.createElement(
					'li',
					{ className: 'swipeout transitioning', ref: 'node' },
					_react2.default.createElement(
						'div',
						{ ref: 'container' },
						_react2.default.createElement(
							'div',
							{ className: 'item-content swipeout-content' },
							_react2.default.createElement(
								'div',
								{ className: 'item-media' },
								_react2.default.createElement(
									'i',
									{ className: 'icon icon-red' },
									'S'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'item-inner', style: { minHeight: 50 } },
								_react2.default.createElement(
									'div',
									{ className: 'item-title' },
									text
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'swipeout-actions-right' },
							_react2.default.createElement(
								'a',
								{ href: 'javascript:;', className: 'demo-actions', onClick: this.handleAction },
								'More'
							),
							_react2.default.createElement(
								'a',
								{ href: 'javascript:;', className: 'swipeout-delete', onClick: this.handleAction },
								'Delete'
							)
						)
					)
				);
			}
		}]);
	
		return SwipeToShowTowActions;
	}(_react.Component);
	
	var SwipeToShowActionOnRight = function (_Component3) {
		_inherits(SwipeToShowActionOnRight, _Component3);
	
		function SwipeToShowActionOnRight() {
			var _ref11;
	
			var _temp3, _this3, _ret3;
	
			_classCallCheck(this, SwipeToShowActionOnRight);
	
			for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
				args[_key3] = arguments[_key3];
			}
	
			return _ret3 = (_temp3 = (_this3 = _possibleConstructorReturn(this, (_ref11 = SwipeToShowActionOnRight.__proto__ || Object.getPrototypeOf(SwipeToShowActionOnRight)).call.apply(_ref11, [this].concat(args))), _this3), _this3.handleOuterTouchStart = function (_ref12) {
				var target = _ref12.target;
	
				var node = _this3.refs.node;
				if (node !== target && !node.contains(target)) {
					_this3.pullElement.animateToOrigin();
				}
			}, _this3.handleAction = function (_ref13) {
				var currentTarget = _ref13.currentTarget;
	
				alert(currentTarget.textContent);
				_this3.pullElement.animateToOrigin();
			}, _temp3), _possibleConstructorReturn(_this3, _ret3);
		}
	
		_createClass(SwipeToShowActionOnRight, [{
			key: 'addPullElement',
			value: function addPullElement() {
				this.pullElement = new _2.default({
					target: this.refs.container,
					wait: false,
					pullLeft: true,
					onPullRightEnd: function onPullRightEnd(_ref14) {
						var translateX = _ref14.translateX;
	
						if (translateX >= 50) {
							this.preventDefault();
							this.animateTo(225, 0);
						}
					}
				});
				this.pullElement.init();
			}
		}, {
			key: 'removePullElement',
			value: function removePullElement() {
				this.pullElement.destroy();
			}
		}, {
			key: 'addOuterTouchStartListener',
			value: function addOuterTouchStartListener() {
				document.addEventListener('touchstart', this.handleOuterTouchStart);
			}
		}, {
			key: 'removeOuterTouchStartListener',
			value: function removeOuterTouchStartListener() {
				document.removeEventListener('touchstart', this.handleOuterTouchStart);
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.addPullElement();
				this.addOuterTouchStartListener();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.removePullElement();
				this.removeOuterTouchStartListener();
			}
		}, {
			key: 'render',
			value: function render() {
				var text = this.props.text;
	
				return _react2.default.createElement(
					'li',
					{ className: 'swipeout swipeout-opened transitioning', ref: 'node' },
					_react2.default.createElement(
						'div',
						{ ref: 'container' },
						_react2.default.createElement(
							'div',
							{ className: 'item-content swipeout-content' },
							_react2.default.createElement(
								'div',
								{ className: 'item-media' },
								_react2.default.createElement(
									'i',
									{ className: 'icon icon-red' },
									'S'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'item-inner', style: { minHeight: 50 } },
								_react2.default.createElement(
									'div',
									{ className: 'item-title' },
									text
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'swipeout-actions-left swipeout-actions-opened' },
							_react2.default.createElement(
								'a',
								{
									href: 'javascript:;',
									className: 'bg-blue demo-forward',
									onClick: this.handleAction
								},
								'Reply'
							),
							_react2.default.createElement(
								'a',
								{
									href: 'javascript:;',
									className: 'bg-green demo-reply',
									onClick: this.handleAction
								},
								'Forward'
							)
						)
					)
				);
			}
		}]);
	
		return SwipeToShowActionOnRight;
	}(_react.Component);
	
	var SwipeToShowActionOnBothSide = function (_Component4) {
		_inherits(SwipeToShowActionOnBothSide, _Component4);
	
		function SwipeToShowActionOnBothSide() {
			var _ref15;
	
			var _temp4, _this4, _ret4;
	
			_classCallCheck(this, SwipeToShowActionOnBothSide);
	
			for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
				args[_key4] = arguments[_key4];
			}
	
			return _ret4 = (_temp4 = (_this4 = _possibleConstructorReturn(this, (_ref15 = SwipeToShowActionOnBothSide.__proto__ || Object.getPrototypeOf(SwipeToShowActionOnBothSide)).call.apply(_ref15, [this].concat(args))), _this4), _this4.handleOuterTouchStart = function (_ref16) {
				var target = _ref16.target;
	
				var node = _this4.refs.node;
				if (node !== target && !node.contains(target)) {
					_this4.pullElement.animateToOrigin();
				}
			}, _this4.handleAction = function (_ref17) {
				var currentTarget = _ref17.currentTarget;
	
				alert(currentTarget.textContent);
				_this4.pullElement.animateToOrigin();
			}, _temp4), _possibleConstructorReturn(_this4, _ret4);
		}
	
		_createClass(SwipeToShowActionOnBothSide, [{
			key: 'addPullElement',
			value: function addPullElement() {
				this.pullElement = new _2.default({
					target: this.refs.container,
					wait: false,
					onPullLeftEnd: function onPullLeftEnd(_ref18) {
						var translateX = _ref18.translateX;
	
						if (-translateX >= 50) {
							this.preventDefault();
							this.animateTo(-305, 0);
						}
					},
					onPullRightEnd: function onPullRightEnd(_ref19) {
						var translateX = _ref19.translateX;
	
						if (translateX >= 50) {
							this.preventDefault();
							this.animateTo(225, 0);
						}
					}
				});
				this.pullElement.init();
			}
		}, {
			key: 'removePullElement',
			value: function removePullElement() {
				this.pullElement.destroy();
			}
		}, {
			key: 'addOuterTouchStartListener',
			value: function addOuterTouchStartListener() {
				document.addEventListener('touchstart', this.handleOuterTouchStart);
			}
		}, {
			key: 'removeOuterTouchStartListener',
			value: function removeOuterTouchStartListener() {
				document.removeEventListener('touchstart', this.handleOuterTouchStart);
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.addPullElement();
				this.addOuterTouchStartListener();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.removePullElement();
				this.removeOuterTouchStartListener();
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'li',
					{ className: 'swipeout transitioning', ref: 'node' },
					_react2.default.createElement(
						'div',
						{ ref: 'container' },
						_react2.default.createElement(
							'div',
							{ className: 'swipeout-content' },
							_react2.default.createElement(
								'a',
								{ href: 'javascript:;', className: 'item-link item-content' },
								_react2.default.createElement(
									'div',
									{ className: 'item-inner', style: { minHeight: 50 } },
									_react2.default.createElement(
										'div',
										{ className: 'item-title-row' },
										_react2.default.createElement(
											'div',
											{ className: 'item-title' },
											'Facebook'
										),
										_react2.default.createElement(
											'div',
											{ className: 'item-after' },
											'17:14'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'item-subtitle' },
										'New messages from John Doe'
									),
									_react2.default.createElement(
										'div',
										{ className: 'item-text' },
										'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla sagittis tellus ut turpis condimentum, ut dignissim lacus tincidunt. Cras dolor metus, ultrices condimentum sodales sit amet, pharetra sodales eros. Phasellus vel felis tellus. Mauris rutrum ligula nec dapibus feugiat. In vel dui laoreet, commodo augue id, pulvinar lacus.'
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'swipeout-actions-left' },
							_react2.default.createElement(
								'a',
								{ href: 'javascript:;', className: 'bg-green swipeout-overswipe demo-reply', onClick: this.handleAction },
								'Reply'
							),
							_react2.default.createElement(
								'a',
								{ href: 'javascript:;', className: 'demo-forward bg-blue', onClick: this.handleAction },
								'Forward'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'swipeout-actions-right' },
							_react2.default.createElement(
								'a',
								{ href: 'javascript:;', className: 'demo-actions', onClick: this.handleAction },
								'More'
							),
							_react2.default.createElement(
								'a',
								{ href: 'javascript:;', className: 'demo-mark bg-orange', onClick: this.handleAction },
								'Mark'
							),
							_react2.default.createElement(
								'a',
								{ href: 'javascript:;', className: 'swipeout-delete swipeout-overswipe', onClick: this.handleAction },
								'Delete'
							)
						)
					)
				);
			}
		}]);
	
		return SwipeToShowActionOnBothSide;
	}(_react.Component);

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ = __webpack_require__(2);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SwipeableTabs = function (_Component) {
		_inherits(SwipeableTabs, _Component);
	
		function SwipeableTabs() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, SwipeableTabs);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SwipeableTabs.__proto__ || Object.getPrototypeOf(SwipeableTabs)).call.apply(_ref, [this].concat(args))), _this), _this.activeIndex = 0, _this.handleSwitchTab = function (_ref2) {
				var currentTarget = _ref2.currentTarget;
	
				var index = Number(currentTarget.getAttribute('data-index'));
				_this.activeIndex = index;
				_this.switchTab(index);
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(SwipeableTabs, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var component = this;
				var _refs = this.refs,
				    target = _refs.target,
				    tabs = _refs.tabs;
	
				var clientWidth = target.clientWidth;
				var handlePullEnd = function handlePullEnd(_ref3) {
					var translateX = _ref3.translateX;
	
					this.preventDefault();
					var activeIndex = component.activeIndex;
					var diff = activeIndex + translateX / clientWidth;
					if (diff > 0.2) {
						activeIndex -= 1;
					} else if (diff < -0.2) {
						activeIndex += 1;
					}
					if (activeIndex < 0) {
						activeIndex = 0;
					} else if (activeIndex > 2) {
						activeIndex = 2;
					}
					component.activeIndex = activeIndex;
					component.switchTab(activeIndex);
				};
				this.pullElement = new _2.default({
					target: target,
					wait: false,
					onPullLeftEnd: handlePullEnd,
					onPullRightEnd: handlePullEnd
				});
				this.pullElement.init();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.pullElement.destroy();
			}
		}, {
			key: 'switchTab',
			value: function switchTab(index) {
				this.animateTo(index);
				this.switchAtiveStatus(index);
			}
		}, {
			key: 'animateTo',
			value: function animateTo(index) {
				var _refs2 = this.refs,
				    target = _refs2.target,
				    tabs = _refs2.tabs;
	
				var translateX = -target.clientWidth * index;
				this.pullElement.animateTo(translateX, 0);
			}
		}, {
			key: 'switchAtiveStatus',
			value: function switchAtiveStatus(activeIndex) {
				var tabItems = Array.from(this.refs.tabs.querySelectorAll('.tab-link'));
				tabItems.forEach(function (elem, index) {
					if (activeIndex === index) {
						elem.classList.add('active');
					} else {
						elem.classList.remove('active');
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'views' },
					_react2.default.createElement(
						'div',
						{ className: 'view view-main' },
						_react2.default.createElement(
							'div',
							{ className: 'navbar' },
							_react2.default.createElement(
								'div',
								{ className: 'navbar-inner' },
								_react2.default.createElement(
									'div',
									{ className: 'left sliding' },
									_react2.default.createElement(
										'a',
										{ href: '#/', className: 'back link' },
										_react2.default.createElement('i', { className: 'icon icon-back' }),
										_react2.default.createElement(
											'span',
											null,
											'Back'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'center sliding' },
									'Swipeable Tabs'
								),
								_react2.default.createElement(
									'div',
									{ className: 'right' },
									_react2.default.createElement(
										'a',
										{ href: '#/', className: 'link open-panel icon-only' },
										_react2.default.createElement('i', { className: 'icon icon-bars' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'subnavbar sliding' },
									_react2.default.createElement(
										'div',
										{ className: 'buttons-row', ref: 'tabs' },
										_react2.default.createElement(
											'a',
											{
												href: 'javascript:;',
												className: 'button active tab-link',
												'data-index': '0',
												onClick: this.handleSwitchTab
											},
											'Tab 1'
										),
										_react2.default.createElement(
											'a',
											{
												href: 'javascript:;',
												className: 'button tab-link',
												'data-index': '1',
												onClick: this.handleSwitchTab
											},
											'Tab 2'
										),
										_react2.default.createElement(
											'a',
											{
												href: 'javascript:;',
												className: 'button tab-link',
												'data-index': '2',
												onClick: this.handleSwitchTab
											},
											'Tab 3'
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'pages navbar-through' },
							_react2.default.createElement(
								'div',
								{ 'data-page': 'tabs-animated', className: 'page with-subnavbar' },
								_react2.default.createElement(
									'div',
									{ className: 'tabs-animated-wrap' },
									_react2.default.createElement('style', { type: 'text/css', dangerouslySetInnerHTML: { __html: '\n\t\t\t\t        \t\t\t.tabs-animated-wrap>.tabs {\n\t\t\t\t        \t\t\t\t -webkit-transition-duration: 0ms;\n    \t\t\t\t\t\t\t\t\t transition-duration: 0ms;\n\t\t\t\t        \t\t\t}\n\t\t\t\t        \t\t' } }),
									_react2.default.createElement(
										'div',
										{ className: 'tabs', ref: 'target' },
										_react2.default.createElement(
											'div',
											{ id: 'tab1', className: 'page-content tab' },
											_react2.default.createElement(
												'div',
												{ className: 'content-block' },
												_react2.default.createElement(
													'p',
													null,
													'This is tab 1 content'
												),
												_react2.default.createElement(
													'p',
													null,
													'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque elementum mi quis felis scelerisque faucibus. Aliquam ut commodo justo. Mauris vitae pharetra arcu. Sed tincidunt dui et nibh auctor pretium. Nam accumsan fermentum sem. Suspendisse potenti. Nulla sed orci malesuada, pellentesque elit vitae, cursus lorem. Praesent et vehicula sapien, ut rhoncus quam. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vitae mi nec lorem aliquet venenatis quis nec nibh. Aenean sit amet leo ligula. Fusce in massa et nisl dictum ultricies et vitae dui. Sed sagittis quis diam sed lobortis. Donec in massa pharetra, tristique purus vitae, consequat mauris. Aliquam tellus ante, pharetra in mattis ut, dictum quis erat.'
												),
												_react2.default.createElement(
													'p',
													null,
													'Ut ac lobortis lacus, non pellentesque arcu. Quisque sodales sapien malesuada, condimentum nunc at, viverra lacus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Vivamus eu pulvinar turpis, id tristique quam. Aenean venenatis molestie diam, sit amet condimentum nisl pretium id. Donec diam tortor, mollis in vehicula id, vehicula consectetur nulla. Quisque posuere rutrum mauris, eu rutrum turpis blandit at. Proin volutpat tortor sit amet metus porttitor accumsan. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Ut dapibus posuere dictum.'
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ id: 'tab2', className: 'page-content tab' },
											_react2.default.createElement(
												'div',
												{ className: 'content-block' },
												_react2.default.createElement(
													'p',
													null,
													'This is tab 2 content'
												),
												_react2.default.createElement(
													'p',
													null,
													'Ut ac lobortis lacus, non pellentesque arcu. Quisque sodales sapien malesuada, condimentum nunc at, viverra lacus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Vivamus eu pulvinar turpis, id tristique quam. Aenean venenatis molestie diam, sit amet condimentum nisl pretium id. Donec diam tortor, mollis in vehicula id, vehicula consectetur nulla. Quisque posuere rutrum mauris, eu rutrum turpis blandit at. Proin volutpat tortor sit amet metus porttitor accumsan. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Ut dapibus posuere dictum.'
												),
												_react2.default.createElement(
													'p',
													null,
													'Fusce luctus turpis nunc, id porta orci blandit eget. Aenean sodales quam nec diam varius, in ornare ipsum condimentum. Aenean eleifend, nulla sit amet volutpat adipiscing, ligula nulla pharetra risus, vitae consequat leo tortor eu nunc. Vivamus at fringilla metus. Duis neque lectus, sagittis in volutpat a, pretium vel turpis. Nam accumsan auctor libero, quis sodales felis faucibus quis. Etiam vestibulum sed nisl vel aliquet. Aliquam pellentesque leo a lacus ultricies scelerisque. Vestibulum vestibulum fermentum tincidunt. Proin eleifend metus non quam pretium, eu vehicula ipsum egestas. Nam eget nibh enim. Etiam sem leo, pellentesque a elit vel, egestas rhoncus enim. Morbi ultricies adipiscing tortor, vitae condimentum lacus hendrerit nec. Phasellus laoreet leo quis purus elementum, ut fringilla justo eleifend. Nunc ultricies a sapien vitae auctor. Aliquam id erat elementum, laoreet est et, dapibus ligula.'
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ id: 'tab3', className: 'page-content tab' },
											_react2.default.createElement(
												'div',
												{ className: 'content-block' },
												_react2.default.createElement(
													'p',
													null,
													'This is tab 3 content'
												),
												_react2.default.createElement(
													'p',
													null,
													'Nulla gravida libero eget lobortis iaculis. In sed elit eu nibh adipiscing faucibus. Sed ac accumsan lacus. In ut diam quis turpis fringilla volutpat. In ultrices dignissim consequat. Cras pretium tortor et lorem condimentum posuere. Nulla facilisi. Suspendisse pretium egestas lacus ac laoreet. Mauris rhoncus quis ipsum quis tristique. Vivamus ultricies urna quis nunc egestas, in euismod turpis fringilla. Nam tellus massa, vehicula eu sapien non, dapibus tempor lorem. Fusce placerat orci arcu, eu dignissim enim porttitor vel. Nullam porttitor vel dolor sed feugiat. Suspendisse potenti. Maecenas ac mattis odio. Sed vel ultricies lacus, sed posuere libero.'
												),
												_react2.default.createElement(
													'p',
													null,
													'Nulla gravida libero eget lobortis iaculis. In sed elit eu nibh adipiscing faucibus. Sed ac accumsan lacus. In ut diam quis turpis fringilla volutpat. In ultrices dignissim consequat. Cras pretium tortor et lorem condimentum posuere. Nulla facilisi. Suspendisse pretium egestas lacus ac laoreet. Mauris rhoncus quis ipsum quis tristique. Vivamus ultricies urna quis nunc egestas, in euismod turpis fringilla. Nam tellus massa, vehicula eu sapien non, dapibus tempor lorem. Fusce placerat orci arcu, eu dignissim enim porttitor vel. Nullam porttitor vel dolor sed feugiat. Suspendisse potenti. Maecenas ac mattis odio. Sed vel ultricies lacus, sed posuere libero.'
												)
											)
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return SwipeableTabs;
	}(_react.Component);
	
	exports.default = SwipeableTabs;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ = __webpack_require__(2);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VerticalSwiper = function (_Component) {
		_inherits(VerticalSwiper, _Component);
	
		function VerticalSwiper() {
			_classCallCheck(this, VerticalSwiper);
	
			return _possibleConstructorReturn(this, (VerticalSwiper.__proto__ || Object.getPrototypeOf(VerticalSwiper)).apply(this, arguments));
		}
	
		_createClass(VerticalSwiper, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var component = this;
				var target = this.refs.target;
	
				var clientHeight = target.clientHeight;
				var activeIndex = 0;
				var handlePullEnd = function handlePullEnd(_ref) {
					var translateY = _ref.translateY;
	
					this.preventDefault();
					var prevTranslateY = -activeIndex * clientHeight;
					var diff = translateY - prevTranslateY;
					if (diff > 50) {
						activeIndex -= 1;
					} else if (diff < -50) {
						activeIndex += 1;
					}
					if (activeIndex < 0) {
						activeIndex = 0;
					} else if (activeIndex > 9) {
						activeIndex = 9;
					}
					component.switchSlide(activeIndex);
				};
				this.pullElement = new _2.default({
					target: target,
					isStatic: true,
					wait: false,
					onPullUpEnd: handlePullEnd,
					onPullDownEnd: handlePullEnd
				});
				this.pullElement.init();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.pullElement.destroy();
			}
		}, {
			key: 'switchSlide',
			value: function switchSlide(index) {
				this.animateTo(index);
				this.switchAtiveStatus(index);
			}
		}, {
			key: 'animateTo',
			value: function animateTo(index) {
				var target = this.refs.target;
	
				var translateY = -target.clientHeight * index;
				this.pullElement.animateTo(0, translateY);
			}
		}, {
			key: 'switchAtiveStatus',
			value: function switchAtiveStatus(activeIndex) {
				var tabItems = Array.from(this.refs.paginations.querySelectorAll('.swiper-pagination-bullet'));
				tabItems.forEach(function (elem, index) {
					if (activeIndex === index) {
						elem.classList.add('swiper-pagination-bullet-active');
					} else {
						elem.classList.remove('swiper-pagination-bullet-active');
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'views' },
					_react2.default.createElement(
						'div',
						{ className: 'view view-main' },
						_react2.default.createElement(
							'div',
							{ className: 'navbar' },
							_react2.default.createElement(
								'div',
								{ className: 'navbar-inner' },
								_react2.default.createElement(
									'div',
									{ className: 'left sliding' },
									_react2.default.createElement(
										'a',
										{ href: '#/', className: 'back link' },
										_react2.default.createElement('i', { className: 'icon icon-back' }),
										_react2.default.createElement(
											'span',
											null,
											'Back'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'center sliding' },
									'Vertical Swiper'
								),
								_react2.default.createElement(
									'div',
									{ className: 'right' },
									_react2.default.createElement(
										'a',
										{ href: '#/', className: 'open-panel link icon-only' },
										_react2.default.createElement('i', { className: 'icon icon-bars' })
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'pages navbar-through' },
							_react2.default.createElement(
								'div',
								{ className: 'page page-on-center' },
								_react2.default.createElement(
									'div',
									{ className: 'page-content' },
									_react2.default.createElement(
										'div',
										{ className: 'swiper-container swiper-init ks-demo-slider swiper-container-vertical' },
										_react2.default.createElement(
											'div',
											{ className: 'swiper-pagination swiper-pagination-bullets', ref: 'paginations' },
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet swiper-pagination-bullet-active' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' }),
											_react2.default.createElement('span', { className: 'swiper-pagination-bullet' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'swiper-wrapper', ref: 'target' },
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide' },
												'Slide 1'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide' },
												'Slide 2'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide' },
												'Slide 3'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide' },
												'Slide 4'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide' },
												'Slide 5'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide' },
												'Slide 6'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide' },
												'Slide 7'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide' },
												'Slide 8'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide' },
												'Slide 9'
											),
											_react2.default.createElement(
												'div',
												{ className: 'swiper-slide' },
												'Slide 10'
											)
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return VerticalSwiper;
	}(_react.Component);
	
	exports.default = VerticalSwiper;

/***/ },
/* 20 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = goBack;
	function goBack() {
		history.back();
	}

/***/ },
/* 21 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(6);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(6);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(25);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 25 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 26 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.95bb76d4.js